import { Taf } from "@huyafed/taf-network";

/*!
 * This file was generated by jce-tools 
 */

export var HUYA = HUYA || {};

HUYA.GetGroupListByIdReq = function () {
  this.tId = new HUYA.UserId();
  this.iListId = 0;
  this.iPage = 0;
  this.iFreeFlowFlag = 0;
  this.iStyle = 0;
};

HUYA.GetGroupListByIdReq.prototype.readFrom = function (is) {
  this.tId = is.readStruct(0, false, this.tId);
  this.iListId = is.readInt32(1, false, this.iListId);
  this.iPage = is.readInt32(2, false, this.iPage);
  this.iFreeFlowFlag = is.readInt32(3, false, this.iFreeFlowFlag);
  this.iStyle = is.readInt32(4, false, this.iStyle);
};

HUYA.GetGroupListByIdReq.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tId);
  os.writeInt32(1, this.iListId);
  os.writeInt32(2, this.iPage);
  os.writeInt32(3, this.iFreeFlowFlag);
  os.writeInt32(4, this.iStyle);
};

HUYA.GetGroupListByIdReq.prototype._clone = function () {
  return new HUYA.GetGroupListByIdReq();
};
HUYA.GetGroupListByIdReq.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GetGroupListByIdReq.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserId = function () {
  this.lUid = 0;
  this.sGuid = "";
  this.sToken = "";
  this.sHuYaUA = "";
  this.sCookie = "";
  this.iTokenType = 0;
  this.sDeviceInfo = "";
  this.sQIMEI = "";
};

HUYA.UserId.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sGuid = is.readString(1, false, this.sGuid);
  this.sToken = is.readString(2, false, this.sToken);
  this.sHuYaUA = is.readString(3, false, this.sHuYaUA);
  this.sCookie = is.readString(4, false, this.sCookie);
  this.iTokenType = is.readInt32(5, false, this.iTokenType);
  this.sDeviceInfo = is.readString(6, false, this.sDeviceInfo);
  this.sQIMEI = is.readString(7, false, this.sQIMEI);
};

HUYA.UserId.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sGuid);
  os.writeString(2, this.sToken);
  os.writeString(3, this.sHuYaUA);
  os.writeString(4, this.sCookie);
  os.writeInt32(5, this.iTokenType);
  os.writeString(6, this.sDeviceInfo);
  os.writeString(7, this.sQIMEI);
};

HUYA.UserId.prototype._clone = function () {
  return new HUYA.UserId();
};
HUYA.UserId.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserId.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GetGroupListByIdRsp = function () {
  this.vGroupListItem = new Taf.Vector(new HUYA.VidoGroupListItem());
  this.iHasMore = 0;
};

HUYA.GetGroupListByIdRsp.prototype.readFrom = function (is) {
  this.vGroupListItem = is.readVector(0, false, this.vGroupListItem);
  this.iHasMore = is.readInt32(1, false, this.iHasMore);
};

HUYA.GetGroupListByIdRsp.prototype.writeTo = function (os) {
  os.writeVector(0, this.vGroupListItem);
  os.writeInt32(1, this.iHasMore);
};

HUYA.GetGroupListByIdRsp.prototype._clone = function () {
  return new HUYA.GetGroupListByIdRsp();
};
HUYA.GetGroupListByIdRsp.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GetGroupListByIdRsp.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VidoGroupListItem = function () {
  this.iDataType = 0;
  this.tMoment = new HUYA.VideoGroupMomentItem();
  this.tPresenter = new HUYA.VideoGroupPresenterItem();
  this.tTopic = new HUYA.VideoTopic();
  this.tMomentList = new HUYA.VideoGroupMomentListItem();
};

HUYA.VidoGroupListItem.prototype.readFrom = function (is) {
  this.iDataType = is.readInt32(0, false, this.iDataType);
  this.tMoment = is.readStruct(1, false, this.tMoment);
  this.tPresenter = is.readStruct(2, false, this.tPresenter);
  this.tTopic = is.readStruct(3, false, this.tTopic);
  this.tMomentList = is.readStruct(4, false, this.tMomentList);
};

HUYA.VidoGroupListItem.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iDataType);
  os.writeStruct(1, this.tMoment);
  os.writeStruct(2, this.tPresenter);
  os.writeStruct(3, this.tTopic);
  os.writeStruct(4, this.tMomentList);
};

HUYA.VidoGroupListItem.prototype._clone = function () {
  return new HUYA.VidoGroupListItem();
};
HUYA.VidoGroupListItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VidoGroupListItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoGroupMomentItem = function () {
  this.tMoment = new HUYA.MomentInfo();
  this.iWidth = 0;
  this.iHeight = 0;
};

HUYA.VideoGroupMomentItem.prototype.readFrom = function (is) {
  this.tMoment = is.readStruct(0, false, this.tMoment);
  this.iWidth = is.readInt32(1, false, this.iWidth);
  this.iHeight = is.readInt32(2, false, this.iHeight);
};

HUYA.VideoGroupMomentItem.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tMoment);
  os.writeInt32(1, this.iWidth);
  os.writeInt32(2, this.iHeight);
};

HUYA.VideoGroupMomentItem.prototype._clone = function () {
  return new HUYA.VideoGroupMomentItem();
};
HUYA.VideoGroupMomentItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoGroupMomentItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentInfo = function () {
  this.lMomId = 0;
  this.iType = 0;
  this.lUid = 0;
  this.sNickName = "";
  this.sIconUrl = "";
  this.sTitle = "";
  this.sContent = "";
  this.iFavorCount = 0;
  this.iCommentCount = 0;
  this.iShareCount = 0;
  this.vComment = new Taf.Vector(new HUYA.CommentInfo());
  this.iCTime = 0;
  this.iStatus = 0;
  this.iOpt = 0;
  this.tVideoInfo = new HUYA.VideoInfo();
  this.vKeyWord = new Taf.Vector(new Taf.STRING());
  this.iHasDraw = 0;
  this.vCoverUrl = new Taf.Vector(new Taf.STRING());
  this.sHtmlDoc = "";
  this.vTags = new Taf.Vector(new Taf.STRING());
  this.vBelongPlate = new Taf.Vector(new Taf.STRING());
  this.iBrowseCount = 0;
  this.iCardType = 0;
  this.vMomentAttachment = new Taf.Vector(new HUYA.MomentAttachment());
  this.iStepOnCount = 0;
  this.iUserOpt = 0;
  this.vMomentDecoration = new Taf.Vector(new HUYA.MomentDecorationItem());
  this.iTopStatus = 0;
  this.sTraceId = "";
  this.mpServerContext = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.mpExtInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.sServerContext = "";
};

HUYA.MomentInfo.prototype.readFrom = function (is) {
  this.lMomId = is.readInt64(0, false, this.lMomId);
  this.iType = is.readInt32(1, false, this.iType);
  this.lUid = is.readInt64(2, false, this.lUid);
  this.sNickName = is.readString(3, false, this.sNickName);
  this.sIconUrl = is.readString(4, false, this.sIconUrl);
  this.sTitle = is.readString(5, false, this.sTitle);
  this.sContent = is.readString(6, false, this.sContent);
  this.iFavorCount = is.readInt32(7, false, this.iFavorCount);
  this.iCommentCount = is.readInt32(8, false, this.iCommentCount);
  this.iShareCount = is.readInt32(9, false, this.iShareCount);
  this.vComment = is.readVector(10, false, this.vComment);
  this.iCTime = is.readInt32(11, false, this.iCTime);
  this.iStatus = is.readInt32(12, false, this.iStatus);
  this.iOpt = is.readInt32(13, false, this.iOpt);
  this.tVideoInfo = is.readStruct(14, false, this.tVideoInfo);
  this.vKeyWord = is.readVector(15, false, this.vKeyWord);
  this.iHasDraw = is.readInt32(16, false, this.iHasDraw);
  this.vCoverUrl = is.readVector(17, false, this.vCoverUrl);
  this.sHtmlDoc = is.readString(18, false, this.sHtmlDoc);
  this.vTags = is.readVector(19, false, this.vTags);
  this.vBelongPlate = is.readVector(20, false, this.vBelongPlate);
  this.iBrowseCount = is.readInt32(21, false, this.iBrowseCount);
  this.iCardType = is.readInt32(22, false, this.iCardType);
  this.vMomentAttachment = is.readVector(23, false, this.vMomentAttachment);
  this.iStepOnCount = is.readInt32(24, false, this.iStepOnCount);
  this.iUserOpt = is.readInt32(25, false, this.iUserOpt);
  this.vMomentDecoration = is.readVector(26, false, this.vMomentDecoration);
  this.iTopStatus = is.readInt32(27, false, this.iTopStatus);
  this.sTraceId = is.readString(28, false, this.sTraceId);
  this.mpServerContext = is.readMap(29, false, this.mpServerContext);
  this.mpExtInfo = is.readMap(30, false, this.mpExtInfo);
  this.sServerContext = is.readString(31, false, this.sServerContext);
};

HUYA.MomentInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lMomId);
  os.writeInt32(1, this.iType);
  os.writeInt64(2, this.lUid);
  os.writeString(3, this.sNickName);
  os.writeString(4, this.sIconUrl);
  os.writeString(5, this.sTitle);
  os.writeString(6, this.sContent);
  os.writeInt32(7, this.iFavorCount);
  os.writeInt32(8, this.iCommentCount);
  os.writeInt32(9, this.iShareCount);
  os.writeVector(10, this.vComment);
  os.writeInt32(11, this.iCTime);
  os.writeInt32(12, this.iStatus);
  os.writeInt32(13, this.iOpt);
  os.writeStruct(14, this.tVideoInfo);
  os.writeVector(15, this.vKeyWord);
  os.writeInt32(16, this.iHasDraw);
  os.writeVector(17, this.vCoverUrl);
  os.writeString(18, this.sHtmlDoc);
  os.writeVector(19, this.vTags);
  os.writeVector(20, this.vBelongPlate);
  os.writeInt32(21, this.iBrowseCount);
  os.writeInt32(22, this.iCardType);
  os.writeVector(23, this.vMomentAttachment);
  os.writeInt32(24, this.iStepOnCount);
  os.writeInt32(25, this.iUserOpt);
  os.writeVector(26, this.vMomentDecoration);
  os.writeInt32(27, this.iTopStatus);
  os.writeString(28, this.sTraceId);
  os.writeMap(29, this.mpServerContext);
  os.writeMap(30, this.mpExtInfo);
  os.writeString(31, this.sServerContext);
};

HUYA.MomentInfo.prototype._clone = function () {
  return new HUYA.MomentInfo();
};
HUYA.MomentInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommentInfo = function () {
  this.lComId = 0;
  this.lParentId = 0;
  this.lMomId = 0;
  this.lUid = 0;
  this.sNickName = "";
  this.sIconUrl = "";
  this.sContent = "";
  this.iCTime = 0;
  this.iFavorCount = 0;
  this.iReplyCount = 0;
  this.vComment = new Taf.Vector(HUYA.CommentInfo);
  this.lReplyToComId = 0;
  this.lReplyToUid = 0;
  this.sReplyToNickName = "";
  this.iStatus = 0;
  this.iOpt = 0;
  this.iFavoredByOnwer = 0;
  this.iTopStatus = 0;
  this.vCommentAttach = new Taf.Vector(new HUYA.CommentAttach());
  this.vTags = new Taf.Vector(new Taf.STRING());
  this.vCornerMark = new Taf.Vector(new HUYA.CommentCornerMark());
  this.mpExtInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.vCommentDeco = new Taf.Vector(new HUYA.CommentDecoration());
  this.sCertSmallIcon = "";
  this.sReplyToCertSmallIcon = "";
};

HUYA.CommentInfo.prototype.readFrom = function (is) {
  this.lComId = is.readInt64(0, false, this.lComId);
  this.lParentId = is.readInt64(1, false, this.lParentId);
  this.lMomId = is.readInt64(2, false, this.lMomId);
  this.lUid = is.readInt64(3, false, this.lUid);
  this.sNickName = is.readString(4, false, this.sNickName);
  this.sIconUrl = is.readString(5, false, this.sIconUrl);
  this.sContent = is.readString(6, false, this.sContent);
  this.iCTime = is.readInt32(7, false, this.iCTime);
  this.iFavorCount = is.readInt32(8, false, this.iFavorCount);
  this.iReplyCount = is.readInt32(9, false, this.iReplyCount);
  this.vComment = is.readVector(10, false, this.vComment);
  this.lReplyToComId = is.readInt64(11, false, this.lReplyToComId);
  this.lReplyToUid = is.readInt64(12, false, this.lReplyToUid);
  this.sReplyToNickName = is.readString(13, false, this.sReplyToNickName);
  this.iStatus = is.readInt32(14, false, this.iStatus);
  this.iOpt = is.readInt32(15, false, this.iOpt);
  this.iFavoredByOnwer = is.readInt32(16, false, this.iFavoredByOnwer);
  this.iTopStatus = is.readInt32(20, false, this.iTopStatus);
  this.vCommentAttach = is.readVector(21, false, this.vCommentAttach);
  this.vTags = is.readVector(22, false, this.vTags);
  this.vCornerMark = is.readVector(23, false, this.vCornerMark);
  this.mpExtInfo = is.readMap(24, false, this.mpExtInfo);
  this.vCommentDeco = is.readVector(25, false, this.vCommentDeco);
  this.sCertSmallIcon = is.readString(26, false, this.sCertSmallIcon);
  this.sReplyToCertSmallIcon = is.readString(
    27,
    false,
    this.sReplyToCertSmallIcon
  );
};

HUYA.CommentInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lComId);
  os.writeInt64(1, this.lParentId);
  os.writeInt64(2, this.lMomId);
  os.writeInt64(3, this.lUid);
  os.writeString(4, this.sNickName);
  os.writeString(5, this.sIconUrl);
  os.writeString(6, this.sContent);
  os.writeInt32(7, this.iCTime);
  os.writeInt32(8, this.iFavorCount);
  os.writeInt32(9, this.iReplyCount);
  os.writeVector(10, this.vComment);
  os.writeInt64(11, this.lReplyToComId);
  os.writeInt64(12, this.lReplyToUid);
  os.writeString(13, this.sReplyToNickName);
  os.writeInt32(14, this.iStatus);
  os.writeInt32(15, this.iOpt);
  os.writeInt32(16, this.iFavoredByOnwer);
  os.writeInt32(20, this.iTopStatus);
  os.writeVector(21, this.vCommentAttach);
  os.writeVector(22, this.vTags);
  os.writeVector(23, this.vCornerMark);
  os.writeMap(24, this.mpExtInfo);
  os.writeVector(25, this.vCommentDeco);
  os.writeString(26, this.sCertSmallIcon);
  os.writeString(27, this.sReplyToCertSmallIcon);
};

HUYA.CommentInfo.prototype._clone = function () {
  return new HUYA.CommentInfo();
};
HUYA.CommentInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommentInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommentAttach = function () {
  this.iType = 0;
  this.sContent = "";
  this.sFileMD5 = "";
  this.vAtContent = new Taf.Vector(new HUYA.MomentAtContent());
  this.iDuration = 0;
};

HUYA.CommentAttach.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.sContent = is.readString(1, false, this.sContent);
  this.sFileMD5 = is.readString(2, false, this.sFileMD5);
  this.vAtContent = is.readVector(3, false, this.vAtContent);
  this.iDuration = is.readInt32(4, false, this.iDuration);
};

HUYA.CommentAttach.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeString(1, this.sContent);
  os.writeString(2, this.sFileMD5);
  os.writeVector(3, this.vAtContent);
  os.writeInt32(4, this.iDuration);
};

HUYA.CommentAttach.prototype._clone = function () {
  return new HUYA.CommentAttach();
};
HUYA.CommentAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommentAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAtContent = function () {
  this.lAtUid = 0;
  this.sAtNick = "";
  this.iBegin = 0;
  this.iEnd = 0;
};

HUYA.MomentAtContent.prototype.readFrom = function (is) {
  this.lAtUid = is.readInt64(0, false, this.lAtUid);
  this.sAtNick = is.readString(1, false, this.sAtNick);
  this.iBegin = is.readInt32(2, false, this.iBegin);
  this.iEnd = is.readInt32(3, false, this.iEnd);
};

HUYA.MomentAtContent.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lAtUid);
  os.writeString(1, this.sAtNick);
  os.writeInt32(2, this.iBegin);
  os.writeInt32(3, this.iEnd);
};

HUYA.MomentAtContent.prototype._clone = function () {
  return new HUYA.MomentAtContent();
};
HUYA.MomentAtContent.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentAtContent.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommentCornerMark = function () {
  this.iId = 0;
  this.sContent = "";
};

HUYA.CommentCornerMark.prototype.readFrom = function (is) {
  this.iId = is.readInt32(0, false, this.iId);
  this.sContent = is.readString(1, false, this.sContent);
};

HUYA.CommentCornerMark.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iId);
  os.writeString(1, this.sContent);
};

HUYA.CommentCornerMark.prototype._clone = function () {
  return new HUYA.CommentCornerMark();
};
HUYA.CommentCornerMark.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommentCornerMark.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommentDecoration = function () {
  this.iType = 0;
  this.vData = new Taf.BinBuffer();
};

HUYA.CommentDecoration.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.vData = is.readBytes(1, false, this.vData);
};

HUYA.CommentDecoration.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeBytes(1, this.vData);
};

HUYA.CommentDecoration.prototype._clone = function () {
  return new HUYA.CommentDecoration();
};
HUYA.CommentDecoration.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommentDecoration.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoInfo = function () {
  this.lUid = 0;
  this.sAvatarUrl = "";
  this.sNickName = "";
  this.lVid = 0;
  this.sVideoTitle = "";
  this.sVideoCover = "";
  this.lVideoPlayNum = 0;
  this.lVideoCommentNum = 0;
  this.sVideoDuration = "";
  this.sVideoUrl = "";
  this.sVideoUploadTime = "";
  this.sVideoChannel = "";
  this.sCategory = "";
  this.vDefinitions = new Taf.Vector(new HUYA.VideoDefinition());
  this.iVideoRecommend = 0;
  this.bVideoDot = false;
  this.lVideoRank = 0;
  this.bVideoHasRanked = false;
  this.sTraceId = "";
  this.lActorUid = 0;
  this.sActorNick = "";
  this.sActorAvatarUrl = "";
  this.iExtPlayTimes = 0;
  this.sVideoBigCover = "";
  this.iCommentCount = 0;
  this.vTags = new Taf.Vector(new Taf.STRING());
  this.iVideoDirection = 0;
  this.sBriefIntroduction = "";
  this.iVideoType = 0;
  this.iFavorCount = 0;
  this.lMomId = 0;
  this.sSubTitle = "";
  this.mMiscData = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.vRawDefinitions = new Taf.Vector(new HUYA.VideoDefinition());
  this.canPlay = 0;
  this.status = 0;
  this.vPortraitCovers = new Taf.Vector(new HUYA.PortraitCover());
};

HUYA.VideoInfo.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sAvatarUrl = is.readString(1, false, this.sAvatarUrl);
  this.sNickName = is.readString(2, false, this.sNickName);
  this.lVid = is.readInt64(3, false, this.lVid);
  this.sVideoTitle = is.readString(4, false, this.sVideoTitle);
  this.sVideoCover = is.readString(5, false, this.sVideoCover);
  this.lVideoPlayNum = is.readInt64(6, false, this.lVideoPlayNum);
  this.lVideoCommentNum = is.readInt64(7, false, this.lVideoCommentNum);
  this.sVideoDuration = is.readString(8, false, this.sVideoDuration);
  this.sVideoUrl = is.readString(9, false, this.sVideoUrl);
  this.sVideoUploadTime = is.readString(10, false, this.sVideoUploadTime);
  this.sVideoChannel = is.readString(11, false, this.sVideoChannel);
  this.sCategory = is.readString(12, false, this.sCategory);
  this.vDefinitions = is.readVector(13, false, this.vDefinitions);
  this.iVideoRecommend = is.readInt32(14, false, this.iVideoRecommend);
  this.bVideoDot = is.readBoolean(15, false, this.bVideoDot);
  this.lVideoRank = is.readInt64(16, false, this.lVideoRank);
  this.bVideoHasRanked = is.readBoolean(17, false, this.bVideoHasRanked);
  this.sTraceId = is.readString(18, false, this.sTraceId);
  this.lActorUid = is.readInt64(19, false, this.lActorUid);
  this.sActorNick = is.readString(20, false, this.sActorNick);
  this.sActorAvatarUrl = is.readString(21, false, this.sActorAvatarUrl);
  this.iExtPlayTimes = is.readInt32(22, false, this.iExtPlayTimes);
  this.sVideoBigCover = is.readString(23, false, this.sVideoBigCover);
  this.iCommentCount = is.readInt32(24, false, this.iCommentCount);
  this.vTags = is.readVector(25, false, this.vTags);
  this.iVideoDirection = is.readInt32(26, false, this.iVideoDirection);
  this.sBriefIntroduction = is.readString(27, false, this.sBriefIntroduction);
  this.iVideoType = is.readInt32(28, false, this.iVideoType);
  this.iFavorCount = is.readInt32(29, false, this.iFavorCount);
  this.lMomId = is.readInt64(30, false, this.lMomId);
  this.sSubTitle = is.readString(31, false, this.sSubTitle);
  this.mMiscData = is.readMap(32, false, this.mMiscData);
  this.vRawDefinitions = is.readVector(33, false, this.vRawDefinitions);
  this.canPlay = is.readInt32(34, false, this.canPlay);
  this.status = is.readInt32(35, false, this.status);
  this.vPortraitCovers = is.readVector(36, false, this.vPortraitCovers);
};

HUYA.VideoInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sAvatarUrl);
  os.writeString(2, this.sNickName);
  os.writeInt64(3, this.lVid);
  os.writeString(4, this.sVideoTitle);
  os.writeString(5, this.sVideoCover);
  os.writeInt64(6, this.lVideoPlayNum);
  os.writeInt64(7, this.lVideoCommentNum);
  os.writeString(8, this.sVideoDuration);
  os.writeString(9, this.sVideoUrl);
  os.writeString(10, this.sVideoUploadTime);
  os.writeString(11, this.sVideoChannel);
  os.writeString(12, this.sCategory);
  os.writeVector(13, this.vDefinitions);
  os.writeInt32(14, this.iVideoRecommend);
  os.writeBoolean(15, this.bVideoDot);
  os.writeInt64(16, this.lVideoRank);
  os.writeBoolean(17, this.bVideoHasRanked);
  os.writeString(18, this.sTraceId);
  os.writeInt64(19, this.lActorUid);
  os.writeString(20, this.sActorNick);
  os.writeString(21, this.sActorAvatarUrl);
  os.writeInt32(22, this.iExtPlayTimes);
  os.writeString(23, this.sVideoBigCover);
  os.writeInt32(24, this.iCommentCount);
  os.writeVector(25, this.vTags);
  os.writeInt32(26, this.iVideoDirection);
  os.writeString(27, this.sBriefIntroduction);
  os.writeInt32(28, this.iVideoType);
  os.writeInt32(29, this.iFavorCount);
  os.writeInt64(30, this.lMomId);
  os.writeString(31, this.sSubTitle);
  os.writeMap(32, this.mMiscData);
  os.writeVector(33, this.vRawDefinitions);
  os.writeInt32(34, this.canPlay);
  os.writeInt32(35, this.status);
  os.writeVector(36, this.vPortraitCovers);
};

HUYA.VideoInfo.prototype._clone = function () {
  return new HUYA.VideoInfo();
};
HUYA.VideoInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoDefinition = function () {
  this.sSize = "";
  this.sWidth = "";
  this.sHeight = "";
  this.sDefinition = "";
  this.sUrl = "";
  this.sM3u8 = "";
  this.sDefName = "";
  this.sTs1Url = "";
  this.sTs1Offset = "";
  this.iLineIndex = 0;
  this.iBitRate = 0;
  this.mpExtraParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.vStreamInfo = new Taf.Vector(new HUYA.VideoStreamInfo());
  this.sCodec = "";
  this.sFormat = "";
  this.sDuration = "";
  this.iM3u8LineIndex = 0;
};

HUYA.VideoDefinition.prototype.readFrom = function (is) {
  this.sSize = is.readString(0, false, this.sSize);
  this.sWidth = is.readString(1, false, this.sWidth);
  this.sHeight = is.readString(2, false, this.sHeight);
  this.sDefinition = is.readString(3, false, this.sDefinition);
  this.sUrl = is.readString(4, false, this.sUrl);
  this.sM3u8 = is.readString(5, false, this.sM3u8);
  this.sDefName = is.readString(6, false, this.sDefName);
  this.sTs1Url = is.readString(7, false, this.sTs1Url);
  this.sTs1Offset = is.readString(8, false, this.sTs1Offset);
  this.iLineIndex = is.readInt32(9, false, this.iLineIndex);
  this.iBitRate = is.readInt32(10, false, this.iBitRate);
  this.mpExtraParam = is.readMap(11, false, this.mpExtraParam);
  this.vStreamInfo = is.readVector(12, false, this.vStreamInfo);
  this.sCodec = is.readString(13, false, this.sCodec);
  this.sFormat = is.readString(14, false, this.sFormat);
  this.sDuration = is.readString(15, false, this.sDuration);
  this.iM3u8LineIndex = is.readInt32(16, false, this.iM3u8LineIndex);
};

HUYA.VideoDefinition.prototype.writeTo = function (os) {
  os.writeString(0, this.sSize);
  os.writeString(1, this.sWidth);
  os.writeString(2, this.sHeight);
  os.writeString(3, this.sDefinition);
  os.writeString(4, this.sUrl);
  os.writeString(5, this.sM3u8);
  os.writeString(6, this.sDefName);
  os.writeString(7, this.sTs1Url);
  os.writeString(8, this.sTs1Offset);
  os.writeInt32(9, this.iLineIndex);
  os.writeInt32(10, this.iBitRate);
  os.writeMap(11, this.mpExtraParam);
  os.writeVector(12, this.vStreamInfo);
  os.writeString(13, this.sCodec);
  os.writeString(14, this.sFormat);
  os.writeString(15, this.sDuration);
  os.writeInt32(16, this.iM3u8LineIndex);
};

HUYA.VideoDefinition.prototype._clone = function () {
  return new HUYA.VideoDefinition();
};
HUYA.VideoDefinition.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoDefinition.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoStreamInfo = function () {
  this.sSize = "";
  this.sWidth = "";
  this.sHeight = "";
  this.sFormat = "";
  this.sUrl = "";
  this.sM3u8 = "";
  this.sTs1Url = "";
  this.sTs1Offset = "";
  this.iBitRate = 0;
  this.sCodec = "";
  this.mpExtraParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.iLineIndex = 0;
  this.iM3u8LineIndex = 0;
};

HUYA.VideoStreamInfo.prototype.readFrom = function (is) {
  this.sSize = is.readString(0, false, this.sSize);
  this.sWidth = is.readString(1, false, this.sWidth);
  this.sHeight = is.readString(2, false, this.sHeight);
  this.sFormat = is.readString(3, false, this.sFormat);
  this.sUrl = is.readString(4, false, this.sUrl);
  this.sM3u8 = is.readString(5, false, this.sM3u8);
  this.sTs1Url = is.readString(6, false, this.sTs1Url);
  this.sTs1Offset = is.readString(7, false, this.sTs1Offset);
  this.iBitRate = is.readInt32(8, false, this.iBitRate);
  this.sCodec = is.readString(9, false, this.sCodec);
  this.mpExtraParam = is.readMap(10, false, this.mpExtraParam);
  this.iLineIndex = is.readInt32(11, false, this.iLineIndex);
  this.iM3u8LineIndex = is.readInt32(12, false, this.iM3u8LineIndex);
};

HUYA.VideoStreamInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.sSize);
  os.writeString(1, this.sWidth);
  os.writeString(2, this.sHeight);
  os.writeString(3, this.sFormat);
  os.writeString(4, this.sUrl);
  os.writeString(5, this.sM3u8);
  os.writeString(6, this.sTs1Url);
  os.writeString(7, this.sTs1Offset);
  os.writeInt32(8, this.iBitRate);
  os.writeString(9, this.sCodec);
  os.writeMap(10, this.mpExtraParam);
  os.writeInt32(11, this.iLineIndex);
  os.writeInt32(12, this.iM3u8LineIndex);
};

HUYA.VideoStreamInfo.prototype._clone = function () {
  return new HUYA.VideoStreamInfo();
};
HUYA.VideoStreamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoStreamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.PortraitCover = function () {
  this.seq = 0;
  this.width = 0;
  this.height = 0;
  this.url = "";
  this.similarGroup = "";
};

HUYA.PortraitCover.prototype.readFrom = function (is) {
  this.seq = is.readInt32(0, false, this.seq);
  this.width = is.readInt32(1, false, this.width);
  this.height = is.readInt32(2, false, this.height);
  this.url = is.readString(3, false, this.url);
  this.similarGroup = is.readString(4, false, this.similarGroup);
};

HUYA.PortraitCover.prototype.writeTo = function (os) {
  os.writeInt32(0, this.seq);
  os.writeInt32(1, this.width);
  os.writeInt32(2, this.height);
  os.writeString(3, this.url);
  os.writeString(4, this.similarGroup);
};

HUYA.PortraitCover.prototype._clone = function () {
  return new HUYA.PortraitCover();
};
HUYA.PortraitCover.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.PortraitCover.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAttachment = function () {
  this.iType = 0;
  this.sContent = "";
  this.sUrl = new Taf.Vector(new HUYA.MomentUrl());
  this.iDataType = 0;
  this.sData = new Taf.BinBuffer();
  this.vAtContent = new Taf.Vector(new HUYA.MomentAtContent());
  this.vAttachLink = new Taf.Vector(new Taf.STRING());
  this.sVoteId = "";
  this.lVideoId = 0;
  this.vAction = new Taf.Vector(new HUYA.MomentUrl());
  this.tInfo = new HUYA.MomentGoodsInfo();
  this.tForwardedMoment = new HUYA.ForwardedMomAttach();
  this.tVote = new HUYA.MomentVoteInfo();
  this.tVideoCollection = new HUYA.MomentVideoCollectionAttach();
  this.vGuessInfo = new Taf.Vector(new HUYA.MomentGuessInfoAttach());
  this.vCommonScoreInfo = new Taf.Vector(new HUYA.MomentCommonScoreInfo());
  this.vCommonScoreObject = new Taf.Vector(
    new HUYA.MomentAttachCommonScoreObject()
  );
};

HUYA.MomentAttachment.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.sContent = is.readString(1, false, this.sContent);
  this.sUrl = is.readVector(2, false, this.sUrl);
  this.iDataType = is.readInt32(3, false, this.iDataType);
  this.sData = is.readBytes(4, false, this.sData);
  this.vAtContent = is.readVector(5, false, this.vAtContent);
  this.vAttachLink = is.readVector(6, false, this.vAttachLink);
  this.sVoteId = is.readString(7, false, this.sVoteId);
  this.lVideoId = is.readInt64(8, false, this.lVideoId);
  this.vAction = is.readVector(9, false, this.vAction);
  this.tInfo = is.readStruct(10, false, this.tInfo);
  this.tForwardedMoment = is.readStruct(12, false, this.tForwardedMoment);
  this.tVote = is.readStruct(13, false, this.tVote);
  this.tVideoCollection = is.readStruct(14, false, this.tVideoCollection);
  this.vGuessInfo = is.readVector(15, false, this.vGuessInfo);
  this.vCommonScoreInfo = is.readVector(16, false, this.vCommonScoreInfo);
  this.vCommonScoreObject = is.readVector(17, false, this.vCommonScoreObject);
};

HUYA.MomentAttachment.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeString(1, this.sContent);
  os.writeVector(2, this.sUrl);
  os.writeInt32(3, this.iDataType);
  os.writeBytes(4, this.sData);
  os.writeVector(5, this.vAtContent);
  os.writeVector(6, this.vAttachLink);
  os.writeString(7, this.sVoteId);
  os.writeInt64(8, this.lVideoId);
  os.writeVector(9, this.vAction);
  os.writeStruct(10, this.tInfo);
  os.writeStruct(12, this.tForwardedMoment);
  os.writeStruct(13, this.tVote);
  os.writeStruct(14, this.tVideoCollection);
  os.writeVector(15, this.vGuessInfo);
  os.writeVector(16, this.vCommonScoreInfo);
  os.writeVector(17, this.vCommonScoreObject);
};

HUYA.MomentAttachment.prototype._clone = function () {
  return new HUYA.MomentAttachment();
};
HUYA.MomentAttachment.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentAttachment.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentUrl = function () {
  this.sCover = "";
  this.sUrl = "";
  this.iDirection = 0;
  this.iDuration = 0;
  this.sFileMD5 = "";
  this.sText = "";
  this.iIsIllegal = 0;
  this.iCoverWidth = 0;
  this.iCoverHeight = 0;
  this.tOriPicMeta = new HUYA.MomentOriginalPicMetaData();
};

HUYA.MomentUrl.prototype.readFrom = function (is) {
  this.sCover = is.readString(0, false, this.sCover);
  this.sUrl = is.readString(1, false, this.sUrl);
  this.iDirection = is.readInt32(2, false, this.iDirection);
  this.iDuration = is.readInt32(3, false, this.iDuration);
  this.sFileMD5 = is.readString(4, false, this.sFileMD5);
  this.sText = is.readString(5, false, this.sText);
  this.iIsIllegal = is.readInt32(6, false, this.iIsIllegal);
  this.iCoverWidth = is.readInt32(7, false, this.iCoverWidth);
  this.iCoverHeight = is.readInt32(9, false, this.iCoverHeight);
  this.tOriPicMeta = is.readStruct(10, false, this.tOriPicMeta);
};

HUYA.MomentUrl.prototype.writeTo = function (os) {
  os.writeString(0, this.sCover);
  os.writeString(1, this.sUrl);
  os.writeInt32(2, this.iDirection);
  os.writeInt32(3, this.iDuration);
  os.writeString(4, this.sFileMD5);
  os.writeString(5, this.sText);
  os.writeInt32(6, this.iIsIllegal);
  os.writeInt32(7, this.iCoverWidth);
  os.writeInt32(9, this.iCoverHeight);
  os.writeStruct(10, this.tOriPicMeta);
};

HUYA.MomentUrl.prototype._clone = function () {
  return new HUYA.MomentUrl();
};
HUYA.MomentUrl.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentUrl.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentOriginalPicMetaData = function () {
  this.iWidth = 0;
  this.iHeight = 0;
};

HUYA.MomentOriginalPicMetaData.prototype.readFrom = function (is) {
  this.iWidth = is.readInt32(0, false, this.iWidth);
  this.iHeight = is.readInt32(1, false, this.iHeight);
};

HUYA.MomentOriginalPicMetaData.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iWidth);
  os.writeInt32(1, this.iHeight);
};

HUYA.MomentOriginalPicMetaData.prototype._clone = function () {
  return new HUYA.MomentOriginalPicMetaData();
};
HUYA.MomentOriginalPicMetaData.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentOriginalPicMetaData.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentGoodsInfo = function () {
  this.vDetail = new Taf.Vector(new HUYA.GoodsDetail());
};

HUYA.MomentGoodsInfo.prototype.readFrom = function (is) {
  this.vDetail = is.readVector(0, false, this.vDetail);
};

HUYA.MomentGoodsInfo.prototype.writeTo = function (os) {
  os.writeVector(0, this.vDetail);
};

HUYA.MomentGoodsInfo.prototype._clone = function () {
  return new HUYA.MomentGoodsInfo();
};
HUYA.MomentGoodsInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentGoodsInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GoodsDetail = function () {
  this.spuId = "";
  this.platform = "";
  this.name = "";
  this.imageUrl = "";
  this.minPrice = 0;
  this.maxPrice = 0;
  this.marketPrice = 0;
  this.sAction = "";
};

HUYA.GoodsDetail.prototype.readFrom = function (is) {
  this.spuId = is.readString(0, false, this.spuId);
  this.platform = is.readString(1, false, this.platform);
  this.name = is.readString(2, false, this.name);
  this.imageUrl = is.readString(3, false, this.imageUrl);
  this.minPrice = is.readInt64(4, false, this.minPrice);
  this.maxPrice = is.readInt64(5, false, this.maxPrice);
  this.marketPrice = is.readInt64(6, false, this.marketPrice);
  this.sAction = is.readString(7, false, this.sAction);
};

HUYA.GoodsDetail.prototype.writeTo = function (os) {
  os.writeString(0, this.spuId);
  os.writeString(1, this.platform);
  os.writeString(2, this.name);
  os.writeString(3, this.imageUrl);
  os.writeInt64(4, this.minPrice);
  os.writeInt64(5, this.maxPrice);
  os.writeInt64(6, this.marketPrice);
  os.writeString(7, this.sAction);
};

HUYA.GoodsDetail.prototype._clone = function () {
  return new HUYA.GoodsDetail();
};
HUYA.GoodsDetail.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GoodsDetail.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.ForwardedMomAttach = function () {
  this.lForwardedMomId = 0;
  this.vForwardMoment = new Taf.Vector(new HUYA.ForwardedMomentAbstract());
  this.vOriginMomentData = new Taf.BinBuffer();
};

HUYA.ForwardedMomAttach.prototype.readFrom = function (is) {
  this.lForwardedMomId = is.readInt64(0, false, this.lForwardedMomId);
  this.vForwardMoment = is.readVector(1, false, this.vForwardMoment);
  this.vOriginMomentData = is.readBytes(2, false, this.vOriginMomentData);
};

HUYA.ForwardedMomAttach.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lForwardedMomId);
  os.writeVector(1, this.vForwardMoment);
  os.writeBytes(2, this.vOriginMomentData);
};

HUYA.ForwardedMomAttach.prototype._clone = function () {
  return new HUYA.ForwardedMomAttach();
};
HUYA.ForwardedMomAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ForwardedMomAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.ForwardedMomentAbstract = function () {
  this.lMomId = 0;
  this.lAuthorUid = 0;
  this.sAuthorNick = "";
  this.sTitle = "";
  this.iHasPicture = 0;
};

HUYA.ForwardedMomentAbstract.prototype.readFrom = function (is) {
  this.lMomId = is.readInt64(0, false, this.lMomId);
  this.lAuthorUid = is.readInt64(1, false, this.lAuthorUid);
  this.sAuthorNick = is.readString(2, false, this.sAuthorNick);
  this.sTitle = is.readString(3, false, this.sTitle);
  this.iHasPicture = is.readInt32(4, false, this.iHasPicture);
};

HUYA.ForwardedMomentAbstract.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lMomId);
  os.writeInt64(1, this.lAuthorUid);
  os.writeString(2, this.sAuthorNick);
  os.writeString(3, this.sTitle);
  os.writeInt32(4, this.iHasPicture);
};

HUYA.ForwardedMomentAbstract.prototype._clone = function () {
  return new HUYA.ForwardedMomentAbstract();
};
HUYA.ForwardedMomentAbstract.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ForwardedMomentAbstract.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentVoteInfo = function () {
  this.sVoteId = "";
  this.sVoteTitle = "";
  this.vVoteOption = new Taf.Vector(new HUYA.MomentVoteOption());
  this.mItemCount = new Taf.Map(new Taf.STRING(), new Taf.INT64());
  this.vUserChoose = new Taf.Vector(new Taf.STRING());
  this.iVoteShowStyle = 0;
  this.lBeginTime = 0;
  this.lEndTime = 0;
};

HUYA.MomentVoteInfo.prototype.readFrom = function (is) {
  this.sVoteId = is.readString(0, false, this.sVoteId);
  this.sVoteTitle = is.readString(1, false, this.sVoteTitle);
  this.vVoteOption = is.readVector(2, false, this.vVoteOption);
  this.mItemCount = is.readMap(3, false, this.mItemCount);
  this.vUserChoose = is.readVector(4, false, this.vUserChoose);
  this.iVoteShowStyle = is.readInt32(5, false, this.iVoteShowStyle);
  this.lBeginTime = is.readInt64(6, false, this.lBeginTime);
  this.lEndTime = is.readInt64(7, false, this.lEndTime);
};

HUYA.MomentVoteInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.sVoteId);
  os.writeString(1, this.sVoteTitle);
  os.writeVector(2, this.vVoteOption);
  os.writeMap(3, this.mItemCount);
  os.writeVector(4, this.vUserChoose);
  os.writeInt32(5, this.iVoteShowStyle);
  os.writeInt64(6, this.lBeginTime);
  os.writeInt64(7, this.lEndTime);
};

HUYA.MomentVoteInfo.prototype._clone = function () {
  return new HUYA.MomentVoteInfo();
};
HUYA.MomentVoteInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentVoteInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentVoteOption = function () {
  this.sOptionId = "";
  this.sTitle = "";
  this.sPicUrl = "";
};

HUYA.MomentVoteOption.prototype.readFrom = function (is) {
  this.sOptionId = is.readString(0, false, this.sOptionId);
  this.sTitle = is.readString(1, false, this.sTitle);
  this.sPicUrl = is.readString(2, false, this.sPicUrl);
};

HUYA.MomentVoteOption.prototype.writeTo = function (os) {
  os.writeString(0, this.sOptionId);
  os.writeString(1, this.sTitle);
  os.writeString(2, this.sPicUrl);
};

HUYA.MomentVoteOption.prototype._clone = function () {
  return new HUYA.MomentVoteOption();
};
HUYA.MomentVoteOption.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentVoteOption.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentVideoCollectionAttach = function () {
  this.iCollectionId = 0;
  this.iNo = 0;
  this.lFirstVid = 0;
};

HUYA.MomentVideoCollectionAttach.prototype.readFrom = function (is) {
  this.iCollectionId = is.readInt32(0, false, this.iCollectionId);
  this.iNo = is.readInt32(1, false, this.iNo);
  this.lFirstVid = is.readInt64(2, false, this.lFirstVid);
};

HUYA.MomentVideoCollectionAttach.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iCollectionId);
  os.writeInt32(1, this.iNo);
  os.writeInt64(2, this.lFirstVid);
};

HUYA.MomentVideoCollectionAttach.prototype._clone = function () {
  return new HUYA.MomentVideoCollectionAttach();
};
HUYA.MomentVideoCollectionAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentVideoCollectionAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentGuessInfoAttach = function () {
  this.vGuessInfo = new Taf.BinBuffer();
  this.tMatchGuessCardInfo = new HUYA.MatchGuessCardInfo();
};

HUYA.MomentGuessInfoAttach.prototype.readFrom = function (is) {
  this.vGuessInfo = is.readBytes(1, false, this.vGuessInfo);
  this.tMatchGuessCardInfo = is.readStruct(2, false, this.tMatchGuessCardInfo);
};

HUYA.MomentGuessInfoAttach.prototype.writeTo = function (os) {
  os.writeBytes(1, this.vGuessInfo);
  os.writeStruct(2, this.tMatchGuessCardInfo);
};

HUYA.MomentGuessInfoAttach.prototype._clone = function () {
  return new HUYA.MomentGuessInfoAttach();
};
HUYA.MomentGuessInfoAttach.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentGuessInfoAttach.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MatchGuessCardInfo = function () {
  this.iScheduleId = 0;
  this.sScheduleName = "";
  this.lBeginTime = 0;
  this.lEndTime = 0;
  this.vTeam = new Taf.Vector(new HUYA.MatchGuessCardTeamInfo());
  this.sJumpUrl = "";
  this.iMatchId = 0;
  this.sScheduleDesc = "";
};

HUYA.MatchGuessCardInfo.prototype.readFrom = function (is) {
  this.iScheduleId = is.readInt32(0, false, this.iScheduleId);
  this.sScheduleName = is.readString(1, false, this.sScheduleName);
  this.lBeginTime = is.readInt64(2, false, this.lBeginTime);
  this.lEndTime = is.readInt64(3, false, this.lEndTime);
  this.vTeam = is.readVector(4, false, this.vTeam);
  this.sJumpUrl = is.readString(5, false, this.sJumpUrl);
  this.iMatchId = is.readInt32(6, false, this.iMatchId);
  this.sScheduleDesc = is.readString(7, false, this.sScheduleDesc);
};

HUYA.MatchGuessCardInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iScheduleId);
  os.writeString(1, this.sScheduleName);
  os.writeInt64(2, this.lBeginTime);
  os.writeInt64(3, this.lEndTime);
  os.writeVector(4, this.vTeam);
  os.writeString(5, this.sJumpUrl);
  os.writeInt32(6, this.iMatchId);
  os.writeString(7, this.sScheduleDesc);
};

HUYA.MatchGuessCardInfo.prototype._clone = function () {
  return new HUYA.MatchGuessCardInfo();
};
HUYA.MatchGuessCardInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MatchGuessCardInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MatchGuessCardTeamInfo = function () {
  this.iTeamId = 0;
  this.sTeamName = "";
  this.sTeamLogo = "";
  this.iScore = 0;
};

HUYA.MatchGuessCardTeamInfo.prototype.readFrom = function (is) {
  this.iTeamId = is.readInt32(0, false, this.iTeamId);
  this.sTeamName = is.readString(1, false, this.sTeamName);
  this.sTeamLogo = is.readString(2, false, this.sTeamLogo);
  this.iScore = is.readInt32(3, false, this.iScore);
};

HUYA.MatchGuessCardTeamInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iTeamId);
  os.writeString(1, this.sTeamName);
  os.writeString(2, this.sTeamLogo);
  os.writeInt32(3, this.iScore);
};

HUYA.MatchGuessCardTeamInfo.prototype._clone = function () {
  return new HUYA.MatchGuessCardTeamInfo();
};
HUYA.MatchGuessCardTeamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MatchGuessCardTeamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentCommonScoreInfo = function () {
  this.lObjListId = 0;
};

HUYA.MomentCommonScoreInfo.prototype.readFrom = function (is) {
  this.lObjListId = is.readInt64(0, false, this.lObjListId);
};

HUYA.MomentCommonScoreInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lObjListId);
};

HUYA.MomentCommonScoreInfo.prototype._clone = function () {
  return new HUYA.MomentCommonScoreInfo();
};
HUYA.MomentCommonScoreInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentCommonScoreInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAttachCommonScoreObject = function () {
  this.lObjId = 0;
};

HUYA.MomentAttachCommonScoreObject.prototype.readFrom = function (is) {
  this.lObjId = is.readInt64(0, false, this.lObjId);
};

HUYA.MomentAttachCommonScoreObject.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lObjId);
};

HUYA.MomentAttachCommonScoreObject.prototype._clone = function () {
  return new HUYA.MomentAttachCommonScoreObject();
};
HUYA.MomentAttachCommonScoreObject.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
HUYA.MomentAttachCommonScoreObject.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentDecorationItem = function () {
  this.iType = 0;
  this.vData = new Taf.BinBuffer();
};

HUYA.MomentDecorationItem.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.vData = is.readBytes(1, false, this.vData);
};

HUYA.MomentDecorationItem.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeBytes(1, this.vData);
};

HUYA.MomentDecorationItem.prototype._clone = function () {
  return new HUYA.MomentDecorationItem();
};
HUYA.MomentDecorationItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentDecorationItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoGroupPresenterItem = function () {
  this.vUser = new Taf.Vector(new HUYA.UserBase());
  this.sAction = "";
  this.iTotal = 0;
};

HUYA.VideoGroupPresenterItem.prototype.readFrom = function (is) {
  this.vUser = is.readVector(0, false, this.vUser);
  this.sAction = is.readString(1, false, this.sAction);
  this.iTotal = is.readInt32(2, false, this.iTotal);
};

HUYA.VideoGroupPresenterItem.prototype.writeTo = function (os) {
  os.writeVector(0, this.vUser);
  os.writeString(1, this.sAction);
  os.writeInt32(2, this.iTotal);
};

HUYA.VideoGroupPresenterItem.prototype._clone = function () {
  return new HUYA.VideoGroupPresenterItem();
};
HUYA.VideoGroupPresenterItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoGroupPresenterItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserBase = function () {
  this.lUid = 0;
  this.sNickName = "";
  this.sAvatarUrl = "";
  this.iGender = 0;
  this.lYYId = 0;
  this.iCertified = 0;
  this.iSubscribedCount = 0;
  this.iSubscribeToCount = 0;
  this.iUserLevel = 0;
  this.lUserExp = 0;
  this.iBirthday = 0;
  this.sSign = "";
  this.sArea = "";
  this.sLocation = "";
  this.sRegisterTime = "";
  this.iFreezeTime = 0;
  this.iBindPhone = 0;
  this.sHuyaId = "";
  this.iModifyNickChannel = 0;
  this.iLogoutStatus = 0;
  this.lUserType = 0;
};

HUYA.UserBase.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sNickName = is.readString(1, false, this.sNickName);
  this.sAvatarUrl = is.readString(2, false, this.sAvatarUrl);
  this.iGender = is.readInt32(3, false, this.iGender);
  this.lYYId = is.readInt64(4, false, this.lYYId);
  this.iCertified = is.readInt32(5, false, this.iCertified);
  this.iSubscribedCount = is.readInt32(6, false, this.iSubscribedCount);
  this.iSubscribeToCount = is.readInt32(7, false, this.iSubscribeToCount);
  this.iUserLevel = is.readInt32(8, false, this.iUserLevel);
  this.lUserExp = is.readInt64(9, false, this.lUserExp);
  this.iBirthday = is.readInt32(10, false, this.iBirthday);
  this.sSign = is.readString(11, false, this.sSign);
  this.sArea = is.readString(12, false, this.sArea);
  this.sLocation = is.readString(13, false, this.sLocation);
  this.sRegisterTime = is.readString(14, false, this.sRegisterTime);
  this.iFreezeTime = is.readInt32(15, false, this.iFreezeTime);
  this.iBindPhone = is.readInt32(16, false, this.iBindPhone);
  this.sHuyaId = is.readString(17, false, this.sHuyaId);
  this.iModifyNickChannel = is.readInt32(18, false, this.iModifyNickChannel);
  this.iLogoutStatus = is.readInt32(20, false, this.iLogoutStatus);
  this.lUserType = is.readInt64(21, false, this.lUserType);
};

HUYA.UserBase.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sNickName);
  os.writeString(2, this.sAvatarUrl);
  os.writeInt32(3, this.iGender);
  os.writeInt64(4, this.lYYId);
  os.writeInt32(5, this.iCertified);
  os.writeInt32(6, this.iSubscribedCount);
  os.writeInt32(7, this.iSubscribeToCount);
  os.writeInt32(8, this.iUserLevel);
  os.writeInt64(9, this.lUserExp);
  os.writeInt32(10, this.iBirthday);
  os.writeString(11, this.sSign);
  os.writeString(12, this.sArea);
  os.writeString(13, this.sLocation);
  os.writeString(14, this.sRegisterTime);
  os.writeInt32(15, this.iFreezeTime);
  os.writeInt32(16, this.iBindPhone);
  os.writeString(17, this.sHuyaId);
  os.writeInt32(18, this.iModifyNickChannel);
  os.writeInt32(20, this.iLogoutStatus);
  os.writeInt64(21, this.lUserType);
};

HUYA.UserBase.prototype._clone = function () {
  return new HUYA.UserBase();
};
HUYA.UserBase.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserBase.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoTopic = function () {
  this.iTopicId = 0;
  this.sTopicTitle = "";
  this.iTopicVideoNum = 0;
  this.sTopicCover = "";
  this.sTopicVideoTitle = "";
  this.sTopicUrl = "";
  this.vVideoMoments = new Taf.Vector(new HUYA.MomentInfo());
  this.vRelatedPid = new Taf.Vector(new Taf.INT64());
  this.sTopicBrief = "";
  this.iTopicViews = 0;
  this.iTopicComments = 0;
  this.iWeight = 0;
  this.sShortTitle = "";
  this.iEnableHotSort = 0;
  this.sDetailUrl = "";
  this.vSort = new Taf.Vector(new Taf.INT32());
  this.iDefaultSort = 0;
  this.sCatagray = "";
  this.iRankType = 0;
  this.sTag = "";
  this.vTalker = new Taf.Vector(new HUYA.UserBase());
  this.iDisplayEnchance = 0;
  this.vRelatedKeyword = new Taf.Vector(new Taf.STRING());
  this.iTemplateType = 0;
  this.lPostTemplateId = 0;
  this.sTopicStatistics = "";
  this.lCreateTime = 0;
  this.lMainMomId = 0;
  this.lMainVId = 0;
  this.sHotSpotGrade = "";
};

HUYA.VideoTopic.prototype.readFrom = function (is) {
  this.iTopicId = is.readInt32(0, false, this.iTopicId);
  this.sTopicTitle = is.readString(1, false, this.sTopicTitle);
  this.iTopicVideoNum = is.readInt32(2, false, this.iTopicVideoNum);
  this.sTopicCover = is.readString(3, false, this.sTopicCover);
  this.sTopicVideoTitle = is.readString(4, false, this.sTopicVideoTitle);
  this.sTopicUrl = is.readString(5, false, this.sTopicUrl);
  this.vVideoMoments = is.readVector(6, false, this.vVideoMoments);
  this.vRelatedPid = is.readVector(7, false, this.vRelatedPid);
  this.sTopicBrief = is.readString(8, false, this.sTopicBrief);
  this.iTopicViews = is.readInt32(9, false, this.iTopicViews);
  this.iTopicComments = is.readInt32(10, false, this.iTopicComments);
  this.iWeight = is.readInt32(11, false, this.iWeight);
  this.sShortTitle = is.readString(12, false, this.sShortTitle);
  this.iEnableHotSort = is.readInt32(13, false, this.iEnableHotSort);
  this.sDetailUrl = is.readString(14, false, this.sDetailUrl);
  this.vSort = is.readVector(15, false, this.vSort);
  this.iDefaultSort = is.readInt32(16, false, this.iDefaultSort);
  this.sCatagray = is.readString(17, false, this.sCatagray);
  this.iRankType = is.readInt32(18, false, this.iRankType);
  this.sTag = is.readString(19, false, this.sTag);
  this.vTalker = is.readVector(20, false, this.vTalker);
  this.iDisplayEnchance = is.readInt32(21, false, this.iDisplayEnchance);
  this.vRelatedKeyword = is.readVector(22, false, this.vRelatedKeyword);
  this.iTemplateType = is.readInt32(23, false, this.iTemplateType);
  this.lPostTemplateId = is.readInt64(24, false, this.lPostTemplateId);
  this.sTopicStatistics = is.readString(25, false, this.sTopicStatistics);
  this.lCreateTime = is.readInt64(26, false, this.lCreateTime);
  this.lMainMomId = is.readInt64(27, false, this.lMainMomId);
  this.lMainVId = is.readInt64(28, false, this.lMainVId);
  this.sHotSpotGrade = is.readString(29, false, this.sHotSpotGrade);
};

HUYA.VideoTopic.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iTopicId);
  os.writeString(1, this.sTopicTitle);
  os.writeInt32(2, this.iTopicVideoNum);
  os.writeString(3, this.sTopicCover);
  os.writeString(4, this.sTopicVideoTitle);
  os.writeString(5, this.sTopicUrl);
  os.writeVector(6, this.vVideoMoments);
  os.writeVector(7, this.vRelatedPid);
  os.writeString(8, this.sTopicBrief);
  os.writeInt32(9, this.iTopicViews);
  os.writeInt32(10, this.iTopicComments);
  os.writeInt32(11, this.iWeight);
  os.writeString(12, this.sShortTitle);
  os.writeInt32(13, this.iEnableHotSort);
  os.writeString(14, this.sDetailUrl);
  os.writeVector(15, this.vSort);
  os.writeInt32(16, this.iDefaultSort);
  os.writeString(17, this.sCatagray);
  os.writeInt32(18, this.iRankType);
  os.writeString(19, this.sTag);
  os.writeVector(20, this.vTalker);
  os.writeInt32(21, this.iDisplayEnchance);
  os.writeVector(22, this.vRelatedKeyword);
  os.writeInt32(23, this.iTemplateType);
  os.writeInt64(24, this.lPostTemplateId);
  os.writeString(25, this.sTopicStatistics);
  os.writeInt64(26, this.lCreateTime);
  os.writeInt64(27, this.lMainMomId);
  os.writeInt64(28, this.lMainVId);
  os.writeString(29, this.sHotSpotGrade);
};

HUYA.VideoTopic.prototype._clone = function () {
  return new HUYA.VideoTopic();
};
HUYA.VideoTopic.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoTopic.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoGroupMomentListItem = function () {
  this.tMomentList = new HUYA.MomentListItem();
  this.iWidth = 0;
  this.iHeight = 0;
};

HUYA.VideoGroupMomentListItem.prototype.readFrom = function (is) {
  this.tMomentList = is.readStruct(0, false, this.tMomentList);
  this.iWidth = is.readInt32(1, false, this.iWidth);
  this.iHeight = is.readInt32(2, false, this.iHeight);
};

HUYA.VideoGroupMomentListItem.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tMomentList);
  os.writeInt32(1, this.iWidth);
  os.writeInt32(2, this.iHeight);
};

HUYA.VideoGroupMomentListItem.prototype._clone = function () {
  return new HUYA.VideoGroupMomentListItem();
};
HUYA.VideoGroupMomentListItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoGroupMomentListItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentListItem = function () {
  this.tMomentInfo = new HUYA.MomentInfo();
  this.tVoteInfo = new HUYA.MomentVoteInfo();
  this.sRolerTag = "";
  this.tBadge = new HUYA.MomentSectionBadge();
  this.tSlotAd = new HUYA.SlotAd();
  this.iDataType = 0;
  this.tTopic = new HUYA.VideoTopicList();
  this.tRelatedList = new HUYA.MomentRelatedList();
  this.vVerifiedIdentity = new Taf.Vector(new HUYA.VerifiedIdentity());
  this.tAuthorInfo = new HUYA.MomentAuthorInfo();
  this.tItemExtInfo = new HUYA.ItemExtraInfo();
  this.iAuthorVisibleOnly = 0;
  this.tAuditTip = new HUYA.MomentAuditTip();
  this.tLiveInfo = new HUYA.LiveCardInfoItem();
  this.sTraceId = "";
  this.vGameDescPicture = new Taf.Vector(new HUYA.GameDescriptPicture());
  this.vListCard = new Taf.Vector(new HUYA.CommonScoreObjectListCard());
  this.vExtVideoCollection = new Taf.Vector(
    new HUYA.ExternalVideoCollectionItem()
  );
};

HUYA.MomentListItem.prototype.readFrom = function (is) {
  this.tMomentInfo = is.readStruct(0, false, this.tMomentInfo);
  this.tVoteInfo = is.readStruct(1, false, this.tVoteInfo);
  this.sRolerTag = is.readString(2, false, this.sRolerTag);
  this.tBadge = is.readStruct(3, false, this.tBadge);
  this.tSlotAd = is.readStruct(4, false, this.tSlotAd);
  this.iDataType = is.readInt32(5, false, this.iDataType);
  this.tTopic = is.readStruct(6, false, this.tTopic);
  this.tRelatedList = is.readStruct(7, false, this.tRelatedList);
  this.vVerifiedIdentity = is.readVector(8, false, this.vVerifiedIdentity);
  this.tAuthorInfo = is.readStruct(9, false, this.tAuthorInfo);
  this.tItemExtInfo = is.readStruct(10, false, this.tItemExtInfo);
  this.iAuthorVisibleOnly = is.readInt32(11, false, this.iAuthorVisibleOnly);
  this.tAuditTip = is.readStruct(12, false, this.tAuditTip);
  this.tLiveInfo = is.readStruct(13, false, this.tLiveInfo);
  this.sTraceId = is.readString(14, false, this.sTraceId);
  this.vGameDescPicture = is.readVector(15, false, this.vGameDescPicture);
  this.vListCard = is.readVector(16, false, this.vListCard);
  this.vExtVideoCollection = is.readVector(17, false, this.vExtVideoCollection);
};

HUYA.MomentListItem.prototype.writeTo = function (os) {
  os.writeStruct(0, this.tMomentInfo);
  os.writeStruct(1, this.tVoteInfo);
  os.writeString(2, this.sRolerTag);
  os.writeStruct(3, this.tBadge);
  os.writeStruct(4, this.tSlotAd);
  os.writeInt32(5, this.iDataType);
  os.writeStruct(6, this.tTopic);
  os.writeStruct(7, this.tRelatedList);
  os.writeVector(8, this.vVerifiedIdentity);
  os.writeStruct(9, this.tAuthorInfo);
  os.writeStruct(10, this.tItemExtInfo);
  os.writeInt32(11, this.iAuthorVisibleOnly);
  os.writeStruct(12, this.tAuditTip);
  os.writeStruct(13, this.tLiveInfo);
  os.writeString(14, this.sTraceId);
  os.writeVector(15, this.vGameDescPicture);
  os.writeVector(16, this.vListCard);
  os.writeVector(17, this.vExtVideoCollection);
};

HUYA.MomentListItem.prototype._clone = function () {
  return new HUYA.MomentListItem();
};
HUYA.MomentListItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentListItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentSectionBadge = function () {
  this.lBadgeId = 0;
  this.sBadgeName = 0;
  this.iBadgeLevel = 0;
  this.tSuper = new HUYA.SuperFansInfo();
  this.sName = "";
};

HUYA.MomentSectionBadge.prototype.readFrom = function (is) {
  this.lBadgeId = is.readInt64(0, false, this.lBadgeId);
  this.sBadgeName = is.readInt64(1, false, this.sBadgeName);
  this.iBadgeLevel = is.readInt32(2, false, this.iBadgeLevel);
  this.tSuper = is.readStruct(3, false, this.tSuper);
  this.sName = is.readString(4, false, this.sName);
};

HUYA.MomentSectionBadge.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lBadgeId);
  os.writeInt64(1, this.sBadgeName);
  os.writeInt32(2, this.iBadgeLevel);
  os.writeStruct(3, this.tSuper);
  os.writeString(4, this.sName);
};

HUYA.MomentSectionBadge.prototype._clone = function () {
  return new HUYA.MomentSectionBadge();
};
HUYA.MomentSectionBadge.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentSectionBadge.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.SuperFansInfo = function () {
  this.lSFExpiredTS = 0;
  this.iSFFlag = 0;
  this.lSFAnnualTS = 0;
  this.iSFVariety = 0;
  this.lOpenTS = 0;
  this.lMemoryDay = 0;
  this.iSFLevel = 0;
};

HUYA.SuperFansInfo.prototype.readFrom = function (is) {
  this.lSFExpiredTS = is.readInt64(0, false, this.lSFExpiredTS);
  this.iSFFlag = is.readInt32(1, false, this.iSFFlag);
  this.lSFAnnualTS = is.readInt64(2, false, this.lSFAnnualTS);
  this.iSFVariety = is.readInt32(3, false, this.iSFVariety);
  this.lOpenTS = is.readInt64(4, false, this.lOpenTS);
  this.lMemoryDay = is.readInt64(5, false, this.lMemoryDay);
  this.iSFLevel = is.readInt32(6, false, this.iSFLevel);
};

HUYA.SuperFansInfo.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lSFExpiredTS);
  os.writeInt32(1, this.iSFFlag);
  os.writeInt64(2, this.lSFAnnualTS);
  os.writeInt32(3, this.iSFVariety);
  os.writeInt64(4, this.lOpenTS);
  os.writeInt64(5, this.lMemoryDay);
  os.writeInt32(6, this.iSFLevel);
};

HUYA.SuperFansInfo.prototype._clone = function () {
  return new HUYA.SuperFansInfo();
};
HUYA.SuperFansInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.SuperFansInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.SlotAd = function () {
  this.id = 0;
  this.showType = 0;
  this.ads = new Taf.Vector(new HUYA.AdInfo());
  this.seq = 0;
  this.rid = "";
  this.extra = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};

HUYA.SlotAd.prototype.readFrom = function (is) {
  this.id = is.readInt32(0, false, this.id);
  this.showType = is.readInt32(1, false, this.showType);
  this.ads = is.readVector(2, false, this.ads);
  this.seq = is.readInt32(3, false, this.seq);
  this.rid = is.readString(4, false, this.rid);
  this.extra = is.readMap(5, false, this.extra);
};

HUYA.SlotAd.prototype.writeTo = function (os) {
  os.writeInt32(0, this.id);
  os.writeInt32(1, this.showType);
  os.writeVector(2, this.ads);
  os.writeInt32(3, this.seq);
  os.writeString(4, this.rid);
  os.writeMap(5, this.extra);
};

HUYA.SlotAd.prototype._clone = function () {
  return new HUYA.SlotAd();
};
HUYA.SlotAd.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.SlotAd.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.AdInfo = function () {
  this.id = "";
  this.sdkConf = "";
  this.imageUrl = "";
  this.iconUrl = "";
  this.title = "";
  this.description = "";
  this.traceid = "";
  this.templateId = 0;
  this.videoUrl = "";
  this.videoDuration = 0;
  this.brand = "";
  this.actionTxt = "";
  this.viewUrl = "";
  this.closeSec = 0;
  this.showSec = 0;
  this.pluginLocate = 0;
  this.pluginWidth = 0;
  this.pluginHeight = 0;
  this.element = new HUYA.Element();
  this.ideaId = 0;
  this.unitId = 0;
  this.extra = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.transferVideoUrl = "";
  this.firstFrameUrl = "";
  this.coverVideoUrl = "";
  this.coverVideoFirstFrameUrl = "";
  this.videoVid = 0;
  this.tags = "";
  this.adExtCommonInfo = new Taf.BinBuffer();
  this.thirdCommonInfos = new Taf.Vector(new HUYA.ThirdCommonInfo());
  this.imageMaterialShowRatio = 0;
  this.videoMaterialShowRatio = 0;
};

HUYA.AdInfo.prototype.readFrom = function (is) {
  this.id = is.readString(0, false, this.id);
  this.sdkConf = is.readString(1, false, this.sdkConf);
  this.imageUrl = is.readString(2, false, this.imageUrl);
  this.iconUrl = is.readString(3, false, this.iconUrl);
  this.title = is.readString(4, false, this.title);
  this.description = is.readString(5, false, this.description);
  this.traceid = is.readString(6, false, this.traceid);
  this.templateId = is.readInt32(7, false, this.templateId);
  this.videoUrl = is.readString(8, false, this.videoUrl);
  this.videoDuration = is.readInt32(9, false, this.videoDuration);
  this.brand = is.readString(10, false, this.brand);
  this.actionTxt = is.readString(11, false, this.actionTxt);
  this.viewUrl = is.readString(12, false, this.viewUrl);
  this.closeSec = is.readInt32(13, false, this.closeSec);
  this.showSec = is.readInt32(14, false, this.showSec);
  this.pluginLocate = is.readInt32(15, false, this.pluginLocate);
  this.pluginWidth = is.readInt32(16, false, this.pluginWidth);
  this.pluginHeight = is.readInt32(17, false, this.pluginHeight);
  this.element = is.readStruct(18, false, this.element);
  this.ideaId = is.readInt64(19, false, this.ideaId);
  this.unitId = is.readInt64(20, false, this.unitId);
  this.extra = is.readMap(23, false, this.extra);
  this.transferVideoUrl = is.readString(24, false, this.transferVideoUrl);
  this.firstFrameUrl = is.readString(25, false, this.firstFrameUrl);
  this.coverVideoUrl = is.readString(26, false, this.coverVideoUrl);
  this.coverVideoFirstFrameUrl = is.readString(
    27,
    false,
    this.coverVideoFirstFrameUrl
  );
  this.videoVid = is.readInt64(29, false, this.videoVid);
  this.tags = is.readString(30, false, this.tags);
  this.adExtCommonInfo = is.readBytes(34, false, this.adExtCommonInfo);
  this.thirdCommonInfos = is.readVector(35, false, this.thirdCommonInfos);
  this.imageMaterialShowRatio = is.readInt32(
    36,
    false,
    this.imageMaterialShowRatio
  );
  this.videoMaterialShowRatio = is.readInt32(
    37,
    false,
    this.videoMaterialShowRatio
  );
};

HUYA.AdInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.id);
  os.writeString(1, this.sdkConf);
  os.writeString(2, this.imageUrl);
  os.writeString(3, this.iconUrl);
  os.writeString(4, this.title);
  os.writeString(5, this.description);
  os.writeString(6, this.traceid);
  os.writeInt32(7, this.templateId);
  os.writeString(8, this.videoUrl);
  os.writeInt32(9, this.videoDuration);
  os.writeString(10, this.brand);
  os.writeString(11, this.actionTxt);
  os.writeString(12, this.viewUrl);
  os.writeInt32(13, this.closeSec);
  os.writeInt32(14, this.showSec);
  os.writeInt32(15, this.pluginLocate);
  os.writeInt32(16, this.pluginWidth);
  os.writeInt32(17, this.pluginHeight);
  os.writeStruct(18, this.element);
  os.writeInt64(19, this.ideaId);
  os.writeInt64(20, this.unitId);
  os.writeMap(23, this.extra);
  os.writeString(24, this.transferVideoUrl);
  os.writeString(25, this.firstFrameUrl);
  os.writeString(26, this.coverVideoUrl);
  os.writeString(27, this.coverVideoFirstFrameUrl);
  os.writeInt64(29, this.videoVid);
  os.writeString(30, this.tags);
  os.writeBytes(34, this.adExtCommonInfo);
  os.writeVector(35, this.thirdCommonInfos);
  os.writeInt32(36, this.imageMaterialShowRatio);
  os.writeInt32(37, this.videoMaterialShowRatio);
};

HUYA.AdInfo.prototype._clone = function () {
  return new HUYA.AdInfo();
};
HUYA.AdInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.AdInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.Element = function () {
  this.id = "";
  this.type = new Taf.INT32();
  this.closeSec = 0;
  this.showSec = 0;
  this.imageUrl = "";
  this.videoUrl = "";
  this.videoDuration = 0;
  this.iconUrl = "";
  this.brand = "";
  this.description = "";
  this.actionTxt = "";
  this.elementId = 0;
  this.elementType = 0;
  this.vid = 0;
  this.firstFrameUrl = "";
  this.transferVideoUrl = "";
  this.tags = "";
  this.adExtCommonInfo = new Taf.BinBuffer();
  this.vid2 = 0;
  this.subVideoUrl = "";
  this.subFirstFrameUrl = "";
  this.subTransferVideoUrl = "";
  this.videoCoverImageUrl = "";
  this.imageMaterialShowRatio = 0;
  this.videoMaterialShowRatio = 0;
};

HUYA.Element.prototype.readFrom = function (is) {
  this.id = is.readString(1, false, this.id);
  this.type = is.readInt32(2, false, this.type);
  this.closeSec = is.readInt32(3, false, this.closeSec);
  this.showSec = is.readInt32(4, false, this.showSec);
  this.imageUrl = is.readString(5, false, this.imageUrl);
  this.videoUrl = is.readString(6, false, this.videoUrl);
  this.videoDuration = is.readInt32(7, false, this.videoDuration);
  this.iconUrl = is.readString(8, false, this.iconUrl);
  this.brand = is.readString(9, false, this.brand);
  this.description = is.readString(10, false, this.description);
  this.actionTxt = is.readString(11, false, this.actionTxt);
  this.elementId = is.readInt64(12, false, this.elementId);
  this.elementType = is.readInt32(13, false, this.elementType);
  this.vid = is.readInt64(14, false, this.vid);
  this.firstFrameUrl = is.readString(15, false, this.firstFrameUrl);
  this.transferVideoUrl = is.readString(16, false, this.transferVideoUrl);
  this.tags = is.readString(17, false, this.tags);
  this.adExtCommonInfo = is.readBytes(20, false, this.adExtCommonInfo);
  this.vid2 = is.readInt64(21, false, this.vid2);
  this.subVideoUrl = is.readString(22, false, this.subVideoUrl);
  this.subFirstFrameUrl = is.readString(23, false, this.subFirstFrameUrl);
  this.subTransferVideoUrl = is.readString(24, false, this.subTransferVideoUrl);
  this.videoCoverImageUrl = is.readString(25, false, this.videoCoverImageUrl);
  this.imageMaterialShowRatio = is.readInt32(
    26,
    false,
    this.imageMaterialShowRatio
  );
  this.videoMaterialShowRatio = is.readInt32(
    27,
    false,
    this.videoMaterialShowRatio
  );
};

HUYA.Element.prototype.writeTo = function (os) {
  os.writeString(1, this.id);
  os.writeInt32(2, this.type);
  os.writeInt32(3, this.closeSec);
  os.writeInt32(4, this.showSec);
  os.writeString(5, this.imageUrl);
  os.writeString(6, this.videoUrl);
  os.writeInt32(7, this.videoDuration);
  os.writeString(8, this.iconUrl);
  os.writeString(9, this.brand);
  os.writeString(10, this.description);
  os.writeString(11, this.actionTxt);
  os.writeInt64(12, this.elementId);
  os.writeInt32(13, this.elementType);
  os.writeInt64(14, this.vid);
  os.writeString(15, this.firstFrameUrl);
  os.writeString(16, this.transferVideoUrl);
  os.writeString(17, this.tags);
  os.writeBytes(20, this.adExtCommonInfo);
  os.writeInt64(21, this.vid2);
  os.writeString(22, this.subVideoUrl);
  os.writeString(23, this.subFirstFrameUrl);
  os.writeString(24, this.subTransferVideoUrl);
  os.writeString(25, this.videoCoverImageUrl);
  os.writeInt32(26, this.imageMaterialShowRatio);
  os.writeInt32(27, this.videoMaterialShowRatio);
};

HUYA.Element.prototype._clone = function () {
  return new HUYA.Element();
};
HUYA.Element.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.Element.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};
HUYA.ElementType = {
  NONE: 0,
  IMAGE: 1,
  AD_VIDEO: 2,
  LOGO: 3,
  BRAND: 4,
  SLOGAN: 5,
  AD_ACTION: 6,
};
HUYA.ThirdCommonInfo = function () {
  this.bizType = 0;
  this.data = new Taf.BinBuffer();
};

HUYA.ThirdCommonInfo.prototype.readFrom = function (is) {
  this.bizType = is.readInt32(1, false, this.bizType);
  this.data = is.readBytes(2, false, this.data);
};

HUYA.ThirdCommonInfo.prototype.writeTo = function (os) {
  os.writeInt32(1, this.bizType);
  os.writeBytes(2, this.data);
};

HUYA.ThirdCommonInfo.prototype._clone = function () {
  return new HUYA.ThirdCommonInfo();
};
HUYA.ThirdCommonInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ThirdCommonInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VideoTopicList = function () {
  this.vVideoTopic = new Taf.Vector(new HUYA.VideoTopic());
};

HUYA.VideoTopicList.prototype.readFrom = function (is) {
  this.vVideoTopic = is.readVector(0, false, this.vVideoTopic);
};

HUYA.VideoTopicList.prototype.writeTo = function (os) {
  os.writeVector(0, this.vVideoTopic);
};

HUYA.VideoTopicList.prototype._clone = function () {
  return new HUYA.VideoTopicList();
};
HUYA.VideoTopicList.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VideoTopicList.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentRelatedList = function () {
  this.sTitle = "";
  this.vMoments = new Taf.Vector(new HUYA.MomentInfo());
  this.lPid = 0;
  this.tUIConf = new HUYA.ModuleUIConf();
  this.tRelatedTopic = new HUYA.VideoTopic();
};

HUYA.MomentRelatedList.prototype.readFrom = function (is) {
  this.sTitle = is.readString(0, false, this.sTitle);
  this.vMoments = is.readVector(1, false, this.vMoments);
  this.lPid = is.readInt64(2, false, this.lPid);
  this.tUIConf = is.readStruct(3, false, this.tUIConf);
  this.tRelatedTopic = is.readStruct(4, false, this.tRelatedTopic);
};

HUYA.MomentRelatedList.prototype.writeTo = function (os) {
  os.writeString(0, this.sTitle);
  os.writeVector(1, this.vMoments);
  os.writeInt64(2, this.lPid);
  os.writeStruct(3, this.tUIConf);
  os.writeStruct(4, this.tRelatedTopic);
};

HUYA.MomentRelatedList.prototype._clone = function () {
  return new HUYA.MomentRelatedList();
};
HUYA.MomentRelatedList.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentRelatedList.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.ModuleUIConf = function () {
  this.sBack = "";
  this.sBackDark = "";
};

HUYA.ModuleUIConf.prototype.readFrom = function (is) {
  this.sBack = is.readString(0, false, this.sBack);
  this.sBackDark = is.readString(1, false, this.sBackDark);
};

HUYA.ModuleUIConf.prototype.writeTo = function (os) {
  os.writeString(0, this.sBack);
  os.writeString(1, this.sBackDark);
};

HUYA.ModuleUIConf.prototype._clone = function () {
  return new HUYA.ModuleUIConf();
};
HUYA.ModuleUIConf.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ModuleUIConf.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.VerifiedIdentity = function () {
  this.iId = 0;
  this.iType = 0;
  this.sName = "";
  this.sIcon = "";
  this.sTag = "";
  this.sAction = "";
};

HUYA.VerifiedIdentity.prototype.readFrom = function (is) {
  this.iId = is.readInt32(0, false, this.iId);
  this.iType = is.readInt32(1, false, this.iType);
  this.sName = is.readString(2, false, this.sName);
  this.sIcon = is.readString(3, false, this.sIcon);
  this.sTag = is.readString(4, false, this.sTag);
  this.sAction = is.readString(5, false, this.sAction);
};

HUYA.VerifiedIdentity.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iId);
  os.writeInt32(1, this.iType);
  os.writeString(2, this.sName);
  os.writeString(3, this.sIcon);
  os.writeString(4, this.sTag);
  os.writeString(5, this.sAction);
};

HUYA.VerifiedIdentity.prototype._clone = function () {
  return new HUYA.VerifiedIdentity();
};
HUYA.VerifiedIdentity.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.VerifiedIdentity.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAuthorInfo = function () {
  this.bLive = 0;
  this.sClickAction = "";
  this.sTechTag = "";
  this.iSubscribed = 0;
  this.bAudioChatRoom = 0;
  this.vDecoration = new Taf.Vector(new HUYA.MomentAuthorDecor());
  this.sCommunityIcon = "";
  this.vCommunityMedal = new Taf.Vector(new HUYA.UserMedal());
};

HUYA.MomentAuthorInfo.prototype.readFrom = function (is) {
  this.bLive = is.readInt32(0, false, this.bLive);
  this.sClickAction = is.readString(1, false, this.sClickAction);
  this.sTechTag = is.readString(2, false, this.sTechTag);
  this.iSubscribed = is.readInt32(3, false, this.iSubscribed);
  this.bAudioChatRoom = is.readInt32(4, false, this.bAudioChatRoom);
  this.vDecoration = is.readVector(5, false, this.vDecoration);
  this.sCommunityIcon = is.readString(6, false, this.sCommunityIcon);
  this.vCommunityMedal = is.readVector(7, false, this.vCommunityMedal);
};

HUYA.MomentAuthorInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.bLive);
  os.writeString(1, this.sClickAction);
  os.writeString(2, this.sTechTag);
  os.writeInt32(3, this.iSubscribed);
  os.writeInt32(4, this.bAudioChatRoom);
  os.writeVector(5, this.vDecoration);
  os.writeString(6, this.sCommunityIcon);
  os.writeVector(7, this.vCommunityMedal);
};

HUYA.MomentAuthorInfo.prototype._clone = function () {
  return new HUYA.MomentAuthorInfo();
};
HUYA.MomentAuthorInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentAuthorInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAuthorDecor = function () {
  this.iType = 0;
  this.vData = new Taf.BinBuffer();
};

HUYA.MomentAuthorDecor.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.vData = is.readBytes(1, false, this.vData);
};

HUYA.MomentAuthorDecor.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeBytes(1, this.vData);
};

HUYA.MomentAuthorDecor.prototype._clone = function () {
  return new HUYA.MomentAuthorDecor();
};
HUYA.MomentAuthorDecor.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentAuthorDecor.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.UserMedal = function () {
  this.iId = 0;
  this.iType = 0;
  this.sName = "";
  this.sIcon = "";
  this.sTag = "";
  this.sDescription = "";
  this.sAction = "";
};

HUYA.UserMedal.prototype.readFrom = function (is) {
  this.iId = is.readInt32(0, false, this.iId);
  this.iType = is.readInt32(1, false, this.iType);
  this.sName = is.readString(2, false, this.sName);
  this.sIcon = is.readString(3, false, this.sIcon);
  this.sTag = is.readString(4, false, this.sTag);
  this.sDescription = is.readString(5, false, this.sDescription);
  this.sAction = is.readString(6, false, this.sAction);
};

HUYA.UserMedal.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iId);
  os.writeInt32(1, this.iType);
  os.writeString(2, this.sName);
  os.writeString(3, this.sIcon);
  os.writeString(4, this.sTag);
  os.writeString(5, this.sDescription);
  os.writeString(6, this.sAction);
};

HUYA.UserMedal.prototype._clone = function () {
  return new HUYA.UserMedal();
};
HUYA.UserMedal.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.UserMedal.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.ItemExtraInfo = function () {
  this.iType = 0;
  this.sDisplayValue = "";
  this.vCornerMarks = new Taf.Vector(new HUYA.CornerMark());
  this.iShowTitle = 1;
  this.vHighlightTag = new Taf.Vector(new HUYA.CommunityGameHighlightTag());
  this.mpMiscInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};

HUYA.ItemExtraInfo.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.sDisplayValue = is.readString(1, false, this.sDisplayValue);
  this.vCornerMarks = is.readVector(2, false, this.vCornerMarks);
  this.iShowTitle = is.readInt32(3, false, this.iShowTitle);
  this.vHighlightTag = is.readVector(4, false, this.vHighlightTag);
  this.mpMiscInfo = is.readMap(5, false, this.mpMiscInfo);
};

HUYA.ItemExtraInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeString(1, this.sDisplayValue);
  os.writeVector(2, this.vCornerMarks);
  os.writeInt32(3, this.iShowTitle);
  os.writeVector(4, this.vHighlightTag);
  os.writeMap(5, this.mpMiscInfo);
};

HUYA.ItemExtraInfo.prototype._clone = function () {
  return new HUYA.ItemExtraInfo();
};
HUYA.ItemExtraInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ItemExtraInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CornerMark = function () {
  this.iPos = 0;
  this.sIcon = "";
  this.sText = "";
  this.sWebCSSClass = "";
  this.sAction = "";
  this.sTextColor = "";
  this.iBackImage = "";
  this.iType = 0;
  this.iId = 0;
  this.mpExtInfo = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};

HUYA.CornerMark.prototype.readFrom = function (is) {
  this.iPos = is.readInt32(0, false, this.iPos);
  this.sIcon = is.readString(1, false, this.sIcon);
  this.sText = is.readString(2, false, this.sText);
  this.sWebCSSClass = is.readString(3, false, this.sWebCSSClass);
  this.sAction = is.readString(4, false, this.sAction);
  this.sTextColor = is.readString(5, false, this.sTextColor);
  this.iBackImage = is.readString(6, false, this.iBackImage);
  this.iType = is.readInt32(7, false, this.iType);
  this.iId = is.readInt32(8, false, this.iId);
  this.mpExtInfo = is.readMap(9, false, this.mpExtInfo);
};

HUYA.CornerMark.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iPos);
  os.writeString(1, this.sIcon);
  os.writeString(2, this.sText);
  os.writeString(3, this.sWebCSSClass);
  os.writeString(4, this.sAction);
  os.writeString(5, this.sTextColor);
  os.writeString(6, this.iBackImage);
  os.writeInt32(7, this.iType);
  os.writeInt32(8, this.iId);
  os.writeMap(9, this.mpExtInfo);
};

HUYA.CornerMark.prototype._clone = function () {
  return new HUYA.CornerMark();
};
HUYA.CornerMark.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CornerMark.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommunityGameHighlightTag = function () {
  this.iId = 0;
  this.sText = "";
  this.sIcon = "";
  this.sBackGround = "";
  this.sJumpUrl = "";
};

HUYA.CommunityGameHighlightTag.prototype.readFrom = function (is) {
  this.iId = is.readInt32(0, false, this.iId);
  this.sText = is.readString(1, false, this.sText);
  this.sIcon = is.readString(2, false, this.sIcon);
  this.sBackGround = is.readString(3, false, this.sBackGround);
  this.sJumpUrl = is.readString(4, false, this.sJumpUrl);
};

HUYA.CommunityGameHighlightTag.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iId);
  os.writeString(1, this.sText);
  os.writeString(2, this.sIcon);
  os.writeString(3, this.sBackGround);
  os.writeString(4, this.sJumpUrl);
};

HUYA.CommunityGameHighlightTag.prototype._clone = function () {
  return new HUYA.CommunityGameHighlightTag();
};
HUYA.CommunityGameHighlightTag.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommunityGameHighlightTag.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MomentAuditTip = function () {
  this.sTips = "";
  this.iAuthorOp = 0;
};

HUYA.MomentAuditTip.prototype.readFrom = function (is) {
  this.sTips = is.readString(0, false, this.sTips);
  this.iAuthorOp = is.readInt32(1, false, this.iAuthorOp);
};

HUYA.MomentAuditTip.prototype.writeTo = function (os) {
  os.writeString(0, this.sTips);
  os.writeInt32(1, this.iAuthorOp);
};

HUYA.MomentAuditTip.prototype._clone = function () {
  return new HUYA.MomentAuditTip();
};
HUYA.MomentAuditTip.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MomentAuditTip.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LiveCardInfoItem = function () {
  this.lUid = 0;
  this.sHuYaId = "";
  this.sNick = "";
  this.sScreenshot = "";
  this.sAvatarUrl = "";
  this.sLiveIntro = "";
  this.iRoomId = 0;
  this.tStream = new HUYA.SimpleStreamInfo();
  this.iAttendeeCount = 0;
  this.iIsSubscribed = 0;
  this.sCatagray = "";
  this.iGameId = 0;
  this.lLiveId = 0;
  this.iLiveCardType = 0;
  this.vExtraInfo = new Taf.Vector(new HUYA.LiveCardExtraInfo());
  this.vCornerMark = new Taf.Vector(new HUYA.CornerMark());
  this.sServerContext = "";
  this.iIsReplay = 0;
  this.sLiveStatusText = "";
  this.sMatchName = "";
  this.sRcmdText = "";
  this.iMatchId = 0;
  this.iMatchUnionId = 0;
  this.iSubsribedCount = 0;
  this.iDirection = 0;
  this.sMatchProfileTitle = "";
  this.iSourceType = 0;
  this.iScreenType = 0;
  this.iLiveStatus = 0;
  this.sHyaction = "";
};

HUYA.LiveCardInfoItem.prototype.readFrom = function (is) {
  this.lUid = is.readInt64(0, false, this.lUid);
  this.sHuYaId = is.readString(1, false, this.sHuYaId);
  this.sNick = is.readString(2, false, this.sNick);
  this.sScreenshot = is.readString(3, false, this.sScreenshot);
  this.sAvatarUrl = is.readString(4, false, this.sAvatarUrl);
  this.sLiveIntro = is.readString(5, false, this.sLiveIntro);
  this.iRoomId = is.readInt32(6, false, this.iRoomId);
  this.tStream = is.readStruct(7, false, this.tStream);
  this.iAttendeeCount = is.readInt32(8, false, this.iAttendeeCount);
  this.iIsSubscribed = is.readInt32(9, false, this.iIsSubscribed);
  this.sCatagray = is.readString(10, false, this.sCatagray);
  this.iGameId = is.readInt32(11, false, this.iGameId);
  this.lLiveId = is.readInt64(12, false, this.lLiveId);
  this.iLiveCardType = is.readInt32(13, false, this.iLiveCardType);
  this.vExtraInfo = is.readVector(14, false, this.vExtraInfo);
  this.vCornerMark = is.readVector(15, false, this.vCornerMark);
  this.sServerContext = is.readString(16, false, this.sServerContext);
  this.iIsReplay = is.readInt32(17, false, this.iIsReplay);
  this.sLiveStatusText = is.readString(18, false, this.sLiveStatusText);
  this.sMatchName = is.readString(19, false, this.sMatchName);
  this.sRcmdText = is.readString(20, false, this.sRcmdText);
  this.iMatchId = is.readInt32(21, false, this.iMatchId);
  this.iMatchUnionId = is.readInt32(22, false, this.iMatchUnionId);
  this.iSubsribedCount = is.readInt32(23, false, this.iSubsribedCount);
  this.iDirection = is.readInt32(24, false, this.iDirection);
  this.sMatchProfileTitle = is.readString(25, false, this.sMatchProfileTitle);
  this.iSourceType = is.readInt32(26, false, this.iSourceType);
  this.iScreenType = is.readInt32(27, false, this.iScreenType);
  this.iLiveStatus = is.readInt32(28, false, this.iLiveStatus);
  this.sHyaction = is.readString(29, false, this.sHyaction);
};

HUYA.LiveCardInfoItem.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lUid);
  os.writeString(1, this.sHuYaId);
  os.writeString(2, this.sNick);
  os.writeString(3, this.sScreenshot);
  os.writeString(4, this.sAvatarUrl);
  os.writeString(5, this.sLiveIntro);
  os.writeInt32(6, this.iRoomId);
  os.writeStruct(7, this.tStream);
  os.writeInt32(8, this.iAttendeeCount);
  os.writeInt32(9, this.iIsSubscribed);
  os.writeString(10, this.sCatagray);
  os.writeInt32(11, this.iGameId);
  os.writeInt64(12, this.lLiveId);
  os.writeInt32(13, this.iLiveCardType);
  os.writeVector(14, this.vExtraInfo);
  os.writeVector(15, this.vCornerMark);
  os.writeString(16, this.sServerContext);
  os.writeInt32(17, this.iIsReplay);
  os.writeString(18, this.sLiveStatusText);
  os.writeString(19, this.sMatchName);
  os.writeString(20, this.sRcmdText);
  os.writeInt32(21, this.iMatchId);
  os.writeInt32(22, this.iMatchUnionId);
  os.writeInt32(23, this.iSubsribedCount);
  os.writeInt32(24, this.iDirection);
  os.writeString(25, this.sMatchProfileTitle);
  os.writeInt32(26, this.iSourceType);
  os.writeInt32(27, this.iScreenType);
  os.writeInt32(28, this.iLiveStatus);
  os.writeString(29, this.sHyaction);
};

HUYA.LiveCardInfoItem.prototype._clone = function () {
  return new HUYA.LiveCardInfoItem();
};
HUYA.LiveCardInfoItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LiveCardInfoItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.SimpleStreamInfo = function () {
  this.sStreamName = "";
  this.sFlvUrl = "";
  this.sFlvUrlSuffix = "";
  this.sFlvAntiCode = "";
  this.iLineIndex = 0;
  this.vFlvIPList = new Taf.Vector(new Taf.STRING());
  this.iIsP2PSupport = 0;
  this.sP2pUrl = "";
  this.sP2pUrlSuffix = "";
  this.sP2pAntiCode = "";
  this.vMultiStreamInfo = new Taf.Vector(new HUYA.MultiStreamInfo());
  this.iBitRate = 0;
  this.iDefaultBitRate = 0;
  this.lFreeFlag = 0;
  this.iIsHEVCSupport = 0;
  this.iHashPolicy = 0;
  this.vP2pIPList = new Taf.Vector(new Taf.STRING());
  this.sHlsUrl = "";
  this.iMobileWifiDefaultBitRate = 0;
  this.iEnableAutoBitRate = 0;
  this.iPriorityRate = 0;
  this.iCdnPolicyLevel = 0;
  this.mpExtArgs = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.sCdnType = "";
  this.iRcmdBitRate = 0;
  this.iTemplate = 0;
};

HUYA.SimpleStreamInfo.prototype.readFrom = function (is) {
  this.sStreamName = is.readString(0, false, this.sStreamName);
  this.sFlvUrl = is.readString(1, false, this.sFlvUrl);
  this.sFlvUrlSuffix = is.readString(2, false, this.sFlvUrlSuffix);
  this.sFlvAntiCode = is.readString(3, false, this.sFlvAntiCode);
  this.iLineIndex = is.readInt32(4, false, this.iLineIndex);
  this.vFlvIPList = is.readVector(5, false, this.vFlvIPList);
  this.iIsP2PSupport = is.readInt32(6, false, this.iIsP2PSupport);
  this.sP2pUrl = is.readString(7, false, this.sP2pUrl);
  this.sP2pUrlSuffix = is.readString(8, false, this.sP2pUrlSuffix);
  this.sP2pAntiCode = is.readString(9, false, this.sP2pAntiCode);
  this.vMultiStreamInfo = is.readVector(10, false, this.vMultiStreamInfo);
  this.iBitRate = is.readInt32(11, false, this.iBitRate);
  this.iDefaultBitRate = is.readInt32(12, false, this.iDefaultBitRate);
  this.lFreeFlag = is.readInt64(13, false, this.lFreeFlag);
  this.iIsHEVCSupport = is.readInt32(14, false, this.iIsHEVCSupport);
  this.iHashPolicy = is.readInt32(15, false, this.iHashPolicy);
  this.vP2pIPList = is.readVector(16, false, this.vP2pIPList);
  this.sHlsUrl = is.readString(17, false, this.sHlsUrl);
  this.iMobileWifiDefaultBitRate = is.readInt32(
    18,
    false,
    this.iMobileWifiDefaultBitRate
  );
  this.iEnableAutoBitRate = is.readInt32(19, false, this.iEnableAutoBitRate);
  this.iPriorityRate = is.readInt32(20, false, this.iPriorityRate);
  this.iCdnPolicyLevel = is.readInt32(21, false, this.iCdnPolicyLevel);
  this.mpExtArgs = is.readMap(22, false, this.mpExtArgs);
  this.sCdnType = is.readString(23, false, this.sCdnType);
  this.iRcmdBitRate = is.readInt32(24, false, this.iRcmdBitRate);
  this.iTemplate = is.readInt32(25, false, this.iTemplate);
};

HUYA.SimpleStreamInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.sStreamName);
  os.writeString(1, this.sFlvUrl);
  os.writeString(2, this.sFlvUrlSuffix);
  os.writeString(3, this.sFlvAntiCode);
  os.writeInt32(4, this.iLineIndex);
  os.writeVector(5, this.vFlvIPList);
  os.writeInt32(6, this.iIsP2PSupport);
  os.writeString(7, this.sP2pUrl);
  os.writeString(8, this.sP2pUrlSuffix);
  os.writeString(9, this.sP2pAntiCode);
  os.writeVector(10, this.vMultiStreamInfo);
  os.writeInt32(11, this.iBitRate);
  os.writeInt32(12, this.iDefaultBitRate);
  os.writeInt64(13, this.lFreeFlag);
  os.writeInt32(14, this.iIsHEVCSupport);
  os.writeInt32(15, this.iHashPolicy);
  os.writeVector(16, this.vP2pIPList);
  os.writeString(17, this.sHlsUrl);
  os.writeInt32(18, this.iMobileWifiDefaultBitRate);
  os.writeInt32(19, this.iEnableAutoBitRate);
  os.writeInt32(20, this.iPriorityRate);
  os.writeInt32(21, this.iCdnPolicyLevel);
  os.writeMap(22, this.mpExtArgs);
  os.writeString(23, this.sCdnType);
  os.writeInt32(24, this.iRcmdBitRate);
  os.writeInt32(25, this.iTemplate);
};

HUYA.SimpleStreamInfo.prototype._clone = function () {
  return new HUYA.SimpleStreamInfo();
};
HUYA.SimpleStreamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.SimpleStreamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MultiStreamInfo = function () {
  this.sDisplayName = "";
  this.iBitRate = 0;
  this.iCodecType = 0;
  this.iCompatibleFlag = 0;
  this.iHEVCBitRate = -1;
  this.iEnable = 1;
  this.iEnableMethod = 0;
  this.sEnableUrl = "";
  this.sTipText = "";
  this.sTagText = "";
  this.sTagUrl = "";
  this.iFrameRate = 0;
  this.iSortValue = 0;
};

HUYA.MultiStreamInfo.prototype.readFrom = function (is) {
  this.sDisplayName = is.readString(0, false, this.sDisplayName);
  this.iBitRate = is.readInt32(1, false, this.iBitRate);
  this.iCodecType = is.readInt32(2, false, this.iCodecType);
  this.iCompatibleFlag = is.readInt32(3, false, this.iCompatibleFlag);
  this.iHEVCBitRate = is.readInt32(4, false, this.iHEVCBitRate);
  this.iEnable = is.readInt32(5, false, this.iEnable);
  this.iEnableMethod = is.readInt32(6, false, this.iEnableMethod);
  this.sEnableUrl = is.readString(7, false, this.sEnableUrl);
  this.sTipText = is.readString(8, false, this.sTipText);
  this.sTagText = is.readString(9, false, this.sTagText);
  this.sTagUrl = is.readString(10, false, this.sTagUrl);
  this.iFrameRate = is.readInt32(11, false, this.iFrameRate);
  this.iSortValue = is.readInt32(12, false, this.iSortValue);
};

HUYA.MultiStreamInfo.prototype.writeTo = function (os) {
  os.writeString(0, this.sDisplayName);
  os.writeInt32(1, this.iBitRate);
  os.writeInt32(2, this.iCodecType);
  os.writeInt32(3, this.iCompatibleFlag);
  os.writeInt32(4, this.iHEVCBitRate);
  os.writeInt32(5, this.iEnable);
  os.writeInt32(6, this.iEnableMethod);
  os.writeString(7, this.sEnableUrl);
  os.writeString(8, this.sTipText);
  os.writeString(9, this.sTagText);
  os.writeString(10, this.sTagUrl);
  os.writeInt32(11, this.iFrameRate);
  os.writeInt32(12, this.iSortValue);
};

HUYA.MultiStreamInfo.prototype._clone = function () {
  return new HUYA.MultiStreamInfo();
};
HUYA.MultiStreamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MultiStreamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.LiveCardExtraInfo = function () {
  this.iType = 0;
  this.vBuffer = new Taf.BinBuffer();
};

HUYA.LiveCardExtraInfo.prototype.readFrom = function (is) {
  this.iType = is.readInt32(0, false, this.iType);
  this.vBuffer = is.readBytes(1, false, this.vBuffer);
};

HUYA.LiveCardExtraInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iType);
  os.writeBytes(1, this.vBuffer);
};

HUYA.LiveCardExtraInfo.prototype._clone = function () {
  return new HUYA.LiveCardExtraInfo();
};
HUYA.LiveCardExtraInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.LiveCardExtraInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.GameDescriptPicture = function () {
  this.sCover = "";
  this.iPictureShowType = 0;
};

HUYA.GameDescriptPicture.prototype.readFrom = function (is) {
  this.sCover = is.readString(0, false, this.sCover);
  this.iPictureShowType = is.readInt32(1, false, this.iPictureShowType);
};

HUYA.GameDescriptPicture.prototype.writeTo = function (os) {
  os.writeString(0, this.sCover);
  os.writeInt32(1, this.iPictureShowType);
};

HUYA.GameDescriptPicture.prototype._clone = function () {
  return new HUYA.GameDescriptPicture();
};
HUYA.GameDescriptPicture.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.GameDescriptPicture.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommonScoreObjectListCard = function () {
  this.vCard = new Taf.Vector(new HUYA.CommonObjectCard());
  this.lObjListId = 0;
  this.iType = 0;
  this.sScoreDataDesc = "";
  this.sListTitle = "";
  this.sAction = "";
  this.tBrief = new HUYA.MatchScheduleBrief();
  this.sHeadBannerColor = "";
  this.sHeadBannerBackIcon = "";
  this.sCardShortTitle = "";
  this.tMatchData = new HUYA.CommScoreObjListCardMatchData();
  this.iDataType = 0;
  this.vCategoryCard = new Taf.Vector(new HUYA.CommonScoreObjectCategoryCard());
  this.mpExt = new Taf.Map(new Taf.STRING(), new Taf.STRING());
};

HUYA.CommonScoreObjectListCard.prototype.readFrom = function (is) {
  this.vCard = is.readVector(0, false, this.vCard);
  this.lObjListId = is.readInt64(1, false, this.lObjListId);
  this.iType = is.readInt32(2, false, this.iType);
  this.sScoreDataDesc = is.readString(3, false, this.sScoreDataDesc);
  this.sListTitle = is.readString(4, false, this.sListTitle);
  this.sAction = is.readString(5, false, this.sAction);
  this.tBrief = is.readStruct(6, false, this.tBrief);
  this.sHeadBannerColor = is.readString(7, false, this.sHeadBannerColor);
  this.sHeadBannerBackIcon = is.readString(8, false, this.sHeadBannerBackIcon);
  this.sCardShortTitle = is.readString(9, false, this.sCardShortTitle);
  this.tMatchData = is.readStruct(10, false, this.tMatchData);
  this.iDataType = is.readInt32(11, false, this.iDataType);
  this.vCategoryCard = is.readVector(12, false, this.vCategoryCard);
  this.mpExt = is.readMap(13, false, this.mpExt);
};

HUYA.CommonScoreObjectListCard.prototype.writeTo = function (os) {
  os.writeVector(0, this.vCard);
  os.writeInt64(1, this.lObjListId);
  os.writeInt32(2, this.iType);
  os.writeString(3, this.sScoreDataDesc);
  os.writeString(4, this.sListTitle);
  os.writeString(5, this.sAction);
  os.writeStruct(6, this.tBrief);
  os.writeString(7, this.sHeadBannerColor);
  os.writeString(8, this.sHeadBannerBackIcon);
  os.writeString(9, this.sCardShortTitle);
  os.writeStruct(10, this.tMatchData);
  os.writeInt32(11, this.iDataType);
  os.writeVector(12, this.vCategoryCard);
  os.writeMap(13, this.mpExt);
};

HUYA.CommonScoreObjectListCard.prototype._clone = function () {
  return new HUYA.CommonScoreObjectListCard();
};
HUYA.CommonScoreObjectListCard.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommonScoreObjectListCard.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommonObjectCard = function () {
  this.lObjectId = 0;
  this.iType = 0;
  this.sAvatarUrl = "";
  this.sName = "";
  this.sDesc = "";
  this.dScore = 0;
  this.lTotalScoreCount = 0;
  this.lUserScore = 0;
  this.lMomId = 0;
  this.sDisplayTitle = "";
  this.sNickName = "";
  this.sIconUrl = "";
  this.sCornerIcon = "";
  this.iListId = 0;
  this.sBackGroundURL = "";
  this.sBackGroundColor = "";
  this.mpExt = new Taf.Map(new Taf.STRING(), new Taf.STRING());
  this.sAvatarOrigin = "";
  this.iPlayerSpecialStyle = 0;
  this.sShareBg = "";
  this.sDynamicBg = "";
  this.sDynamicAvatarPhoto = "";
  this.sPlayerHalfBodyPhoto = "";
  this.sBackGroundURL2024 = "";
  this.sAuthorName = "";
  this.sBelongListName = "";
  this.lBelongListId = 0;
};

HUYA.CommonObjectCard.prototype.readFrom = function (is) {
  this.lObjectId = is.readInt64(0, false, this.lObjectId);
  this.iType = is.readInt32(1, false, this.iType);
  this.sAvatarUrl = is.readString(2, false, this.sAvatarUrl);
  this.sName = is.readString(3, false, this.sName);
  this.sDesc = is.readString(4, false, this.sDesc);
  this.dScore = is.readDouble(5, false, this.dScore);
  this.lTotalScoreCount = is.readInt64(6, false, this.lTotalScoreCount);
  this.lUserScore = is.readInt64(7, false, this.lUserScore);
  this.lMomId = is.readInt64(8, false, this.lMomId);
  this.sDisplayTitle = is.readString(9, false, this.sDisplayTitle);
  this.sNickName = is.readString(10, false, this.sNickName);
  this.sIconUrl = is.readString(11, false, this.sIconUrl);
  this.sCornerIcon = is.readString(12, false, this.sCornerIcon);
  this.iListId = is.readInt32(13, false, this.iListId);
  this.sBackGroundURL = is.readString(14, false, this.sBackGroundURL);
  this.sBackGroundColor = is.readString(15, false, this.sBackGroundColor);
  this.mpExt = is.readMap(16, false, this.mpExt);
  this.sAvatarOrigin = is.readString(17, false, this.sAvatarOrigin);
  this.iPlayerSpecialStyle = is.readInt32(18, false, this.iPlayerSpecialStyle);
  this.sShareBg = is.readString(19, false, this.sShareBg);
  this.sDynamicBg = is.readString(20, false, this.sDynamicBg);
  this.sDynamicAvatarPhoto = is.readString(21, false, this.sDynamicAvatarPhoto);
  this.sPlayerHalfBodyPhoto = is.readString(
    22,
    false,
    this.sPlayerHalfBodyPhoto
  );
  this.sBackGroundURL2024 = is.readString(23, false, this.sBackGroundURL2024);
  this.sAuthorName = is.readString(24, false, this.sAuthorName);
  this.sBelongListName = is.readString(25, false, this.sBelongListName);
  this.lBelongListId = is.readInt64(26, false, this.lBelongListId);
};

HUYA.CommonObjectCard.prototype.writeTo = function (os) {
  os.writeInt64(0, this.lObjectId);
  os.writeInt32(1, this.iType);
  os.writeString(2, this.sAvatarUrl);
  os.writeString(3, this.sName);
  os.writeString(4, this.sDesc);
  os.writeDouble(5, this.dScore);
  os.writeInt64(6, this.lTotalScoreCount);
  os.writeInt64(7, this.lUserScore);
  os.writeInt64(8, this.lMomId);
  os.writeString(9, this.sDisplayTitle);
  os.writeString(10, this.sNickName);
  os.writeString(11, this.sIconUrl);
  os.writeString(12, this.sCornerIcon);
  os.writeInt32(13, this.iListId);
  os.writeString(14, this.sBackGroundURL);
  os.writeString(15, this.sBackGroundColor);
  os.writeMap(16, this.mpExt);
  os.writeString(17, this.sAvatarOrigin);
  os.writeInt32(18, this.iPlayerSpecialStyle);
  os.writeString(19, this.sShareBg);
  os.writeString(20, this.sDynamicBg);
  os.writeString(21, this.sDynamicAvatarPhoto);
  os.writeString(22, this.sPlayerHalfBodyPhoto);
  os.writeString(23, this.sBackGroundURL2024);
  os.writeString(24, this.sAuthorName);
  os.writeString(25, this.sBelongListName);
  os.writeInt64(26, this.lBelongListId);
};

HUYA.CommonObjectCard.prototype._clone = function () {
  return new HUYA.CommonObjectCard();
};
HUYA.CommonObjectCard.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.CommonObjectCard.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.MatchScheduleBrief = function () {
  this.iScheduleId = 0;
  this.sScheduleName = "";
  this.vTeam = new Taf.Vector(new HUYA.ScorePageTeamInfo());
  this.iMatchId = 0;
  this.sMatchName = "";
  this.lRoundStartTime = 0;
};

HUYA.MatchScheduleBrief.prototype.readFrom = function (is) {
  this.iScheduleId = is.readInt32(0, false, this.iScheduleId);
  this.sScheduleName = is.readString(1, false, this.sScheduleName);
  this.vTeam = is.readVector(2, false, this.vTeam);
  this.iMatchId = is.readInt32(3, false, this.iMatchId);
  this.sMatchName = is.readString(4, false, this.sMatchName);
  this.lRoundStartTime = is.readInt64(6, false, this.lRoundStartTime);
};

HUYA.MatchScheduleBrief.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iScheduleId);
  os.writeString(1, this.sScheduleName);
  os.writeVector(2, this.vTeam);
  os.writeInt32(3, this.iMatchId);
  os.writeString(4, this.sMatchName);
  os.writeInt64(6, this.lRoundStartTime);
};

HUYA.MatchScheduleBrief.prototype._clone = function () {
  return new HUYA.MatchScheduleBrief();
};
HUYA.MatchScheduleBrief.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.MatchScheduleBrief.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.ScorePageTeamInfo = function () {
  this.iId = 0;
  this.sName = "";
  this.sIcon = "";
  this.iScore = 0;
};

HUYA.ScorePageTeamInfo.prototype.readFrom = function (is) {
  this.iId = is.readInt32(0, false, this.iId);
  this.sName = is.readString(1, false, this.sName);
  this.sIcon = is.readString(2, false, this.sIcon);
  this.iScore = is.readInt32(3, false, this.iScore);
};

HUYA.ScorePageTeamInfo.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iId);
  os.writeString(1, this.sName);
  os.writeString(2, this.sIcon);
  os.writeInt32(3, this.iScore);
};

HUYA.ScorePageTeamInfo.prototype._clone = function () {
  return new HUYA.ScorePageTeamInfo();
};
HUYA.ScorePageTeamInfo.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ScorePageTeamInfo.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommScoreObjListCardMatchData = function () {
  this.iRound = 0;
  this.sRoundDesc = "";
};

HUYA.CommScoreObjListCardMatchData.prototype.readFrom = function (is) {
  this.iRound = is.readInt32(0, false, this.iRound);
  this.sRoundDesc = is.readString(1, false, this.sRoundDesc);
};

HUYA.CommScoreObjListCardMatchData.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iRound);
  os.writeString(1, this.sRoundDesc);
};

HUYA.CommScoreObjListCardMatchData.prototype._clone = function () {
  return new HUYA.CommScoreObjListCardMatchData();
};
HUYA.CommScoreObjListCardMatchData.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
HUYA.CommScoreObjListCardMatchData.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.CommonScoreObjectCategoryCard = function () {
  this.iCategoryId = 0;
  this.sName = "";
  this.sIcon = "";
  this.dScore = 0;
  this.lTotalScoreCount = 0;
  this.sRelatedObjectIcon = "";
  this.sRelatedObjectName = "";
  this.lMomId = 0;
  this.sDisplayTitle = "";
};

HUYA.CommonScoreObjectCategoryCard.prototype.readFrom = function (is) {
  this.iCategoryId = is.readInt32(0, false, this.iCategoryId);
  this.sName = is.readString(1, false, this.sName);
  this.sIcon = is.readString(2, false, this.sIcon);
  this.dScore = is.readDouble(3, false, this.dScore);
  this.lTotalScoreCount = is.readInt64(4, false, this.lTotalScoreCount);
  this.sRelatedObjectIcon = is.readString(5, false, this.sRelatedObjectIcon);
  this.sRelatedObjectName = is.readString(6, false, this.sRelatedObjectName);
  this.lMomId = is.readInt64(7, false, this.lMomId);
  this.sDisplayTitle = is.readString(8, false, this.sDisplayTitle);
};

HUYA.CommonScoreObjectCategoryCard.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iCategoryId);
  os.writeString(1, this.sName);
  os.writeString(2, this.sIcon);
  os.writeDouble(3, this.dScore);
  os.writeInt64(4, this.lTotalScoreCount);
  os.writeString(5, this.sRelatedObjectIcon);
  os.writeString(6, this.sRelatedObjectName);
  os.writeInt64(7, this.lMomId);
  os.writeString(8, this.sDisplayTitle);
};

HUYA.CommonScoreObjectCategoryCard.prototype._clone = function () {
  return new HUYA.CommonScoreObjectCategoryCard();
};
HUYA.CommonScoreObjectCategoryCard.prototype._write = function (
  os,
  tag,
  value
) {
  os.writeStruct(tag, value);
};
HUYA.CommonScoreObjectCategoryCard.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};

HUYA.ExternalVideoCollectionItem = function () {
  this.iExtAppId = 1;
  this.iInnerCollectionId = 0;
  this.sTitle = "";
  this.sCover = "";
  this.iVidNo = 0;
  this.sHyAction = "";
  this.sOutterCollectionId = "";
  this.lInnerVid = 0;
};

HUYA.ExternalVideoCollectionItem.prototype.readFrom = function (is) {
  this.iExtAppId = is.readInt32(0, false, this.iExtAppId);
  this.iInnerCollectionId = is.readInt32(1, false, this.iInnerCollectionId);
  this.sTitle = is.readString(3, false, this.sTitle);
  this.sCover = is.readString(4, false, this.sCover);
  this.iVidNo = is.readInt32(5, false, this.iVidNo);
  this.sHyAction = is.readString(6, false, this.sHyAction);
  this.sOutterCollectionId = is.readString(7, false, this.sOutterCollectionId);
  this.lInnerVid = is.readInt64(8, false, this.lInnerVid);
};

HUYA.ExternalVideoCollectionItem.prototype.writeTo = function (os) {
  os.writeInt32(0, this.iExtAppId);
  os.writeInt32(1, this.iInnerCollectionId);
  os.writeString(3, this.sTitle);
  os.writeString(4, this.sCover);
  os.writeInt32(5, this.iVidNo);
  os.writeString(6, this.sHyAction);
  os.writeString(7, this.sOutterCollectionId);
  os.writeInt64(8, this.lInnerVid);
};

HUYA.ExternalVideoCollectionItem.prototype._clone = function () {
  return new HUYA.ExternalVideoCollectionItem();
};
HUYA.ExternalVideoCollectionItem.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.ExternalVideoCollectionItem.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};
